<template>
  <div class="carteira-cliente">
    <nav-menu />
    <!-- botão menu rodapé-->
    <div class="w3-display-bottomright" style="position: fixed; z-index: 150;" v-if="exibirMenuRoteiro()">

      <div>
        <button 
          v-on:click="baixarRoteiro(roteiro_selecionado)"
          v-if="mostrar_mais_botoes && (roteiro_selecionado) && (roteiro_selecionado.status == 'PRO')"
          class="w3-btn cor-botao-baixar-roteiro w3-border w3-animate-zoom" 
          style="padding-left: 0px!important; padding-top: 5px!important; border-radius: 35px; width:120px; height:35px; position: fixed; margin-left:-35px; font-size: 12px; margin-top: 10px; border: 4px solid #f7f7f7!important; box-shadow: #6b6b6b 2px 2px 5px 2px;">
          Baixar Roteiro
        </button>
      </div>

      <button 
        v-on:click="baixarRoteiro(roteiro_selecionado)"
        v-if="mostrar_mais_botoes && (roteiro_selecionado) && (roteiro_selecionado.status == 'PRO')"
        class="w3-btn w3-padding cor-botao-baixar-roteiro w3-border w3-animate-zoom" 
        style="padding-left: 14px!important; padding-top: 7px!important; border-radius: 30px; width:50px; height:50px; position: relative; margin-left: 50%; margin-top: 5px; border: 4px solid #f7f7f7!important; box-shadow: #7a7a7a 2px 2px 5px 2px;">
        <i class="fas fa-download"></i>
      </button>

      <div>
        <button 
          v-on:click="excluirRoteiro(roteiro_selecionado, true)"
          v-if="mostrar_mais_botoes && (roteiro_selecionado) && (roteiro_selecionado.status != 'BAI')"
          class="w3-btn cor-botao-remover-roteiro w3-border w3-animate-zoom" 
          style="padding-left: 0px!important; padding-top: 5px!important; border-radius: 35px; width:120px; height:35px; position: fixed; margin-left:-35px; font-size: 12px; margin-top: 10px; border: 4px solid #f7f7f7!important; box-shadow: #6b6b6b 2px 2px 5px 2px;">
          Excluir Roteiro
        </button>
      </div>

      <button 
        v-on:click="excluirRoteiro(roteiro_selecionado, true)"
        v-if="mostrar_mais_botoes && (roteiro_selecionado) && (roteiro_selecionado.status != 'BAI')"
        class="w3-btn w3-padding cor-botao-remover-roteiro w3-border w3-animate-zoom" 
        style="padding-left: 14px!important; padding-top: 7px!important; border-radius: 30px; width:50px; height:50px; position: relative; margin-left: 50%; margin-top: 3px; border: 4px solid #f7f7f7!important; box-shadow: #7a7a7a 2px 2px 5px 2px;">
        <i class="fas fa-trash-alt"></i>
      </button>

      <div>
        <button 
          v-on:click="alterarRoteiro(roteiro_selecionado)"
          v-if="mostrar_mais_botoes && (roteiro_selecionado) && (roteiro_selecionado.status != 'BAI')"
          class="w3-btn cor-botao-alterar-roteiro w3-border w3-animate-zoom" 
          style="padding-left: 0px!important; padding-top: 5px!important; border-radius: 35px; width:120px; height:35px; position: fixed; margin-left:-35px; font-size: 12px; margin-top: 10px; border: 4px solid #f7f7f7!important; box-shadow: #6b6b6b 2px 2px 5px 2px;">
          Alterar Roteiro
        </button>
      </div>
      
      <button
        v-on:click="alterarRoteiro(roteiro_selecionado)"
        v-if="mostrar_mais_botoes && (roteiro_selecionado) && (roteiro_selecionado.status != 'BAI')"
        class="w3-btn cor-botao-alterar-roteiro w3-border w3-animate-zoom" 
        style="padding-left: 14px!important; padding-top: 7px!important; border-radius: 30px; width:50px; height:50px; position: relative; margin-left: 50%; margin-top: 3px; border: 4px solid #f7f7f7!important; box-shadow: #7a7a7a 2px 2px 5px 2px;">
        <i class="fas fa-edit"></i>
      </button>

      <div>
        <button 
          v-if="mostrar_mais_botoes"
          v-on:click="novoRoteiro()"
          class="w3-btn cor-botao-novo-roteiro w3-border w3-animate-zoom" 
          style="padding-left: 0px!important; padding-top: 5px!important; border-radius: 35px; width:120px; height:35px; position: fixed; margin-left:-35px; font-size: 12px; margin-top: 10px; border: 4px solid #f7f7f7!important; box-shadow: #6b6b6b 2px 2px 5px 2px;">
          Novo Roteiro
        </button>
      </div>

      <div>
        <button 
          v-if="mostrar_mais_botoes"
          v-on:click="novoRoteiro()"
          class="w3-btn cor-botao-novo-roteiro w3-border w3-animate-zoom" 
          style="padding-left: 12px!important; padding-top: 7px!important; border-radius: 30px; width:50px; height:50px; position: relative; margin-left:50%; margin-top: 3px; border: 4px solid #f7f7f7!important; box-shadow: #6b6b6b 2px 2px 5px 2px;">
          <i class="fas fa-route"></i>
        </button>
      </div>

      <div>
        <button 
          v-if="mostrar_mais_botoes"
          v-on:click="reprocessar()"
          class="w3-btn cor-botao-atualizar-roteiro w3-border w3-animate-zoom" 
          style="padding-left: 0px!important; padding-top: 5px!important; border-radius: 35px; width:120px; height:35px; position: fixed; margin-left:-35px; font-size: 12px; margin-top: 10px; border: 4px solid #f7f7f7!important; box-shadow: #6b6b6b 2px 2px 5px 2px;">
          Reprocessar
        </button>
      </div>

      <button 
        v-if="mostrar_mais_botoes"
        v-on:click="reprocessar()"
        class="w3-btn w3-padding cor-botao-atualizar-roteiro w3-border w3-animate-zoom" 
        style="padding-left: 14px!important; padding-top: 7px!important; border-radius: 30px; width:50px; height:50px; position: relative; margin-left:50%; margin-top: 3px; border: 4px solid #f7f7f7!important; box-shadow: #7a7a7a 2px 2px 5px 2px;">
        <i class="fas fa-sync"></i>
      </button>
      
      <div class="w3-right w3-padding" >
        <button 
          v-if="!mostrar_mais_botoes"
          @click="mostrar_mais_botoes = true"
          class="w3-btn w3-theme w3-text-white w3-border w3-center" 
          style="padding-left: 14px!important; padding-top: 7px!important; border-radius: 30px; width:50px; height:50px; border: 4px solid #f7f7f7!important; box-shadow: #6b6b6b 2px 2px 5px 2px;">
          <i class="fas fa-list-ul"></i>
        </button>
        
        <button 
          v-if="mostrar_mais_botoes"
          @click="mostrar_mais_botoes = false"
          class="w3-btn w3-theme w3-text-white w3-border" 
          style="border-radius: 30px; width:50px; height:50px; border: 4px solid #f7f7f7!important; box-shadow: #6b6b6b 2px 2px 5px 2px;">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>

    <div class="w3-row w3-padding">

      <div class="w3-bar" style="margin-top: 10px; margin-bottom: 15px;"> 

        <div class="w3-col s6">
          <button 
            class="w3-bar-item w3-transparent w3-padding-small tablink w3-btn w3-indigo active"
            :style="getStyleBotaoAbas('carteira')"
            v-on:click="trocarAba('carteira')">
            <i class="fa fa-users"/>
            Clientes
            <i style="font-size: 10px;" class="fa fa-check-circle w3-right" v-show="aba_selecionada == 'carteira'"/>
          </button>
        </div>

        <div class="w3-col s6">
          <button 
            class="w3-bar-item w3-transparent w3-padding-small tablink w3-btn w3-light-green w3-text-white" 
            :style="getStyleBotaoAbas('roteiro')"
            v-on:click="trocarAba('roteiro')">
            <i class="fa fa-route"/>
            <b>Roteiros</b>
            <i style="font-size: 10px;" class="fa fa-check-circle w3-right" v-show="aba_selecionada == 'roteiro'"/>
          </button>
        </div>

      </div>
       
      <div id="tabRoteiros" v-show="aba_selecionada == 'roteiro'" class="w3-container w3-animate-left w3-margin-top" style="display:none; padding:0px">

        <div style="margin-bottom: 10px;">
      
          <input 
            type="text"
            class="input-pesquisa"
            onclick="this.select()"
            id="txtPesquisaRoteiro"
            placeholder="Buscar roteiro" 
            v-on:keyup="pesquisarPorNomeRoteiro()">
            <button 
              title="Limpar chave de pesquisa"
              class="botao-pesquisa"
              v-on:click="limparPesquisaPorNomeRoteiro()">
              <i class="fa fa-times"></i>
            </button>
          </input>

        </div>

        <label 
          v-show="roteiros.length == 0"> 
          Nenhum resultado encontrado! 
        </label>

        <div class="w3-container card-item w3-border w3-animate-left" :key="index" v-for="(roteiro, index) in roteiros" :style="getStyleFundoRoteiro(roteiro)">

          <div class="w3-col s12">
            
            <legenda>
              <div>Roteiro</div>
              <i v-show="false" slot="referencia" class="fa fa-route cor-icone-endereco"></i>

              <i 
                slot="referencia"
                style="font-size: 14px; border-radius: 30px; border: 1px solid #f7f7f7!important; box-shadow: #7a7a7a 2px 2px 5px 2px;" 
                class="fa fa-circle w3-text-white w3-left" 
                v-on:click="selecionarRoteiro(roteiro)"
                v-show="!roteiro_selecionado || (roteiro.roteiro_visitas_id != roteiro_selecionado.roteiro_visitas_id)"
              />

              <i 
                slot="referencia"
                style="font-size: 18px;" 
                class="fa fa-check-circle w3-text-light-green w3-left" 
                v-on:click="selecionarRoteiro(roteiro)"
                v-show="roteiro_selecionado && (roteiro.roteiro_visitas_id == roteiro_selecionado.roteiro_visitas_id)"
              />

            </legenda>

            &nbsp;
            <strong 
              style="color: #333333; cursor: pointer; text-decoration: underline;" 
              v-on:click="alternarDetalhesVisita(index)">
              {{formatarValor(roteiro.roteiro_visitas_id, 0) + '-' + (roteiro.nome ? roteiro.nome : 'SEM NOME')}}
            </strong>

          </div>

          <div class="w3-col s12 tamanho-fonte-detalhes">
            <legenda>
              <div>Período do roteiro</div>
              <i slot="referencia" class="fa fa-calendar-alt cor-icone-endereco"></i>
            </legenda>
            <label style="color: #333333;">{{getPeriodoRoteiro(roteiro.data_inicial, roteiro.data_final)}}</label>
          </div>

          <div class="w3-col s12" style="font-size: 11px;" v-show="valorInt(roteiro.qtd_vezes_replicar) > 0">
            <legenda>
              <div>Tipo de replicação do roteiro</div>
              <i slot="referencia" class="fa fa-clone w3-text-teal"></i>
            </legenda>
            <label style="color: #333333;">{{ roteiro.qtd_vezes_replicar + ' ' + (valorInt(roteiro.qtd_vezes_replicar) > 1 ? 'vezes' : 'vez') + ' ' + roteiro.replicar_analitico.toLowerCase() }}</label>
          </div>

          <div class="w3-col s12" style="font-size: 11px;" v-show="valorInt(roteiro.roteiro_visitas_origem_id) > 0">
            <legenda>
              <div>Replica do roteiro</div>
              <i slot="referencia" class="fa fa-file-import w3-text-gray"></i>
            </legenda>
            <label style="color: #333333;">{{ roteiro.roteiro_visitas_origem_id + ' - ' + roteiro.nome_roteiro_origem }}</label>
          </div>

          <div class="w3-col s12">
            <strong :style="getStyleStatusRoteiro(roteiro.status)"> {{roteiro.status_analitico}} </strong>
          </div>

          <div class="w3-col s12">
            <div class="w3-round">
              <div 
                v-show="roteiro.percentual_concluido > 0"
                v-bind:class="getStylePercentualConcluido(roteiro.percentual_concluido)" 
                :style="getPercentualConcluido(roteiro.percentual_concluido)">
                {{roteiro.percentual_concluido}}%
              </div>
            </div>
          </div>

          <div class="w3-animate-left" style="padding: 0px;" v-show="roteiro.mostrarDetalhes">

            <div class="tamanho-fonte-detalhes">

              <div class="w3-col s12" style="margin-bottom: 5px; color: #333333;">
                <div style="border-bottom: 2px dotted #a3a3a3; margin-top:5px;" class="w3-col s12"></div>
                <h6 
                  class="fundo-cabecalho-dados">
                  &nbsp;
                  <i class="fas fa-list-ul">
                  </i>&nbsp;
                  <strong> Opções </strong> 
                </h6>
                <div style="border-bottom: 2px dotted #a3a3a3;" class="w3-col s12"></div>
              </div>

              <div class="w3-col s6 m3 l2 w3-center" style="padding-top: 5px;">
                <button 
                  title="Copiar roteiro"
                  style="width:120px; font-weight: normal!important;"
                  v-on:click="copiarRoteiro(roteiro)"
                  class="w3-button cor-botao-copiar-roteiro">
                  <i class="fa fa-paste"></i>
                  Copiar
                </button>
              </div>

              <div v-show="roteiro.status != 'BAI'" class="w3-col s6 m3 l2 w3-center" style="padding-top: 5px;">
                <button 
                  title="Excluir roteiro"
                  style="width:120px; font-weight: normal!important;"
                  v-on:click="excluirRoteiro(roteiro, true)"
                  class="w3-button cor-botao-remover-roteiro">
                  <i class="fa fa-minus-circle"></i>
                  Excluir
                </button>
              </div>

              <div v-show="roteiro.status != 'BAI'" class="w3-col s6 m3 l2 w3-center" style="padding-top: 5px;">
                <button 
                  title="Alterar roteiro"
                  style="width:120px; font-weight: normal!important;"
                  v-on:click="alterarRoteiro(roteiro)"
                  class="w3-button cor-botao-alterar-roteiro">
                  <i class="fa fa-edit"></i>
                  Alterar
                </button>
              </div>

              <div v-show="roteiro.status != 'BAI'" class="w3-col s6 m3 l2 w3-center" style="padding-top: 5px;">
                <button 
                  title="Baixar roteiro"
                  style="width:120px; font-weight: normal!important;"
                  v-on:click="baixarRoteiro(roteiro)"
                  class="w3-button cor-botao-baixar-roteiro">
                  <i class="fa fa-download"></i>
                  Baixar
                </button>
              </div>

            </div>

            <div class="w3-col s12" v-show="roteiro.itens_roteiro && roteiro.itens_roteiro.length > 0">

              <div style="border-bottom: 2px dotted #a3a3a3; margin-top:5px;" class="w3-col"></div>
              <h6 
                class="fundo-cabecalho-dados">
                &nbsp;
                <i class="fas fa-calendar-check">
                </i>&nbsp;
                <strong style="color: #333333;"> Visitas </strong> 
              </h6>
              <div style="border-bottom: 2px dotted #a3a3a3;" class="w3-col"></div>
              <div style="margin-bottom:10px;" />

              <div class="w3-container card-item w3-border" v-show="roteiro.itens_roteiro" :key="item_roteiro.visita_id" v-for="(item_roteiro) in roteiro.itens_roteiro">

                <div class="w3-col s12">
                  <div class="circulo-letra w3-center w3-circle">{{getPrimeiraLetraNome(item_roteiro.nome_cliente)}}</div>
                  <strong style="color: #333333; cursor: pointer;">{{item_roteiro.cadastro_id + '-' + item_roteiro.nome_cliente}}</strong>
                </div>

                <div class="w3-col s12 tamanho-fonte-detalhes" v-show="item_roteiro.data_hora_prevista">
                  <label>Data/hora prevista: {{item_roteiro.data_hora_prevista}}</label>
                </div>

                <div class="w3-col s12 tamanho-fonte-detalhes" v-show="item_roteiro.data_hora_check_in">
                  <label>Check-in: {{item_roteiro.data_hora_check_in}}</label>
                </div>

                <div class="w3-col s12 tamanho-fonte-detalhes" v-show="item_roteiro.data_hora_check_out">
                  <label>Check-out: {{item_roteiro.data_hora_check_out}}</label>
                </div>  
                
                <div class="w3-col S12 tamanho-fonte-detalhes">
                  <legenda>
                    <div>Status da visita</div>
                    <i 
                      slot="referencia"
                      :style="getStyleStatusVisita(item_roteiro.status)"
                      :class="getIconeStatus(item_roteiro.status)">
                    </i>
                  </legenda>
                  <strong 
                    :style="getStyleStatusVisita(item_roteiro.status)">
                    {{item_roteiro.status_analitico}}
                  </strong>
                </div>

                <div class="w3-col S12 tamanho-fonte-detalhes">
                  <legenda>
                    <div>Resultado da visita</div>
                    <i 
                      slot="referencia" 
                      :style="getStyleResultado(item_roteiro.resultado)"
                      :class="getIconeResultado(item_roteiro.resultado)"
                    ></i>
                  </legenda>
                  <strong 
                    :style="getStyleResultado(item_roteiro.resultado)">
                    {{item_roteiro.resultado_analitico}}
                  </strong>
                </div>              
              
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="tabCarteira" v-show="aba_selecionada == 'carteira'" class="w3-container w3-animate-left w3-margin-top" style="display:none; padding:0px">

        <div v-if="roteiro_selecionado" style="margin-bottom: 10px; margin-top: -5px;">
          <legenda>
            <div>Nome do roteiro</div>
            <i slot="referencia" class="fa fa-route cor-icone-endereco"></i>
          </legenda>
          
          <strong 
            style="color: #333333;">
            {{formatarValor(roteiro_selecionado.roteiro_visitas_id, 0) + '-' + (roteiro_selecionado.nome ? roteiro_selecionado.nome : 'SEM NOME')}}
          </strong>
          <br/>

          <legenda>
            <div>Período do roteiro</div>
            <i slot="referencia" class="fa fa-calendar-alt cor-icone-endereco"></i>
          </legenda>
          <strong style="color: #333333;">{{getPeriodoRoteiro(roteiro_selecionado.data_inicial, roteiro_selecionado.data_final)}}</strong>

          <div> 
            <strong :style="getStyleStatusRoteiro(roteiro_selecionado.status)"> {{roteiro_selecionado.status_analitico}} </strong>
          </div>

          <div 
            v-show="roteiro_selecionado && (roteiro_selecionado.percentual_concluido > 0)"
            v-bind:class="getStylePercentualConcluido(roteiro_selecionado.percentual_concluido)" 
            :style="getPercentualConcluido(roteiro_selecionado.percentual_concluido)">
            {{roteiro_selecionado.percentual_concluido}}%
          </div>

        </div>

        <div style="margin-bottom: 10px;">
      
          <input 
            type="text"
            class="input-pesquisa"
            onclick="this.select()"
            id="txtPesquisaCliente"
            placeholder="Buscar cliente" 
            v-on:keyup="pesquisarPorNomeCliente()">
            <button 
              title="Limpar chave de pesquisa"
              class="botao-pesquisa"
              v-on:click="limparPesquisaPorNomeCliente()">
              <i class="fa fa-times"></i>
            </button>
          </input>

        </div>

        <label 
          v-show="clientes_carteira.length == 0"> 
          Nenhum resultado encontrado! 
        </label>

        <div :key="index" v-for="(cliente, index) in clientes_carteira">

          <div v-show="cliente.exibir_titulo_visita">

            <div style="border-bottom: 2px dotted #a3a3a3; margin-top: 15px;"/>
            <h6 
              style="margin-top: 0px;"
              class="fundo-cabecalho-dados">
              &nbsp;
              <i style="color: #333333;" class="fas fa-calendar-check"/>
              &nbsp;
              <strong style="color: #333333;" >Visitas agendadas</strong> 
            </h6>
            <div style="border-bottom: 2px dotted #a3a3a3; margin-bottom: 10px;"/>
          
          </div>

          <div v-show="cliente.exibir_titulo_carteira">

            <div style="border-bottom: 2px dotted #a3a3a3; margin-top: 15px;"/>
            <h6 
              style="margin-top: 0px;"
              class="fundo-cabecalho-dados">
              &nbsp;
              <i style="color: #333333;" class="fas fa-users"/>
              &nbsp;
              <strong style="color: #333333;"> Carteira de clientes </strong> 
            </h6>
            <div style="border-bottom: 2px dotted #a3a3a3; margin-bottom: 10px;"/>
          
          </div>

          <div class="w3-container card-item w3-border w3-animate-left" :style="getCorFundoStatusVisita(cliente)">

            <div class="w3-col s12" v-on:click="alternarDetalhesCliente(index)">
              <div class="circulo-letra w3-center w3-circle">{{getPrimeiraLetraNome(cliente.nome_fantasia)}}</div>
              <strong style="color: #333333; cursor: pointer; text-decoration: underline;">{{cliente.nome_fantasia}}</strong>
            </div>

            <div class="w3-col s6 tamanho-fonte-detalhes">
              <legenda>
                <div>Código do cliente</div>
                <i
                  slot="referencia"
                  style="color: #7d3131;"
                  class="fa fa-user">
                </i>
              </legenda>
              <label>{{formatarValor(cliente.cadastro_id, 0)}}</label>
            </div>

            <div class="w3-col s6 w3-right tamanho-fonte-detalhes">
              <label v-show="cliente.tipo_pessoa == 'F'">{{cliente.cpf}}</label>
              <label v-show="cliente.tipo_pessoa == 'J'">{{cliente.cnpj}}</label>
            </div>

            <div class="w3-col s12 tamanho-fonte-detalhes" v-show="!cliente.mostrarDetalhes && cliente.data_hora_prevista">
              <legenda>
                <div>Data/hora da visita</div>
                <i slot="referencia" class="fa fa-calendar-alt cor-icone-endereco"></i>
              </legenda>
              <label style="color: #333333;">{{cliente.data_hora_prevista}}</label>
            </div>

            <div class="w3-col S12 tamanho-fonte-detalhes" v-show="!cliente.mostrarDetalhes">
              <legenda>
                <div>Status da visita</div>
                <i 
                  slot="referencia"
                  :style="getStyleStatusVisita(cliente.status)"
                  :class="getIconeStatus(cliente.status)">
                </i>
              </legenda>
              <strong 
                :style="getStyleStatusVisita(cliente.status)">
                {{cliente.status_analitico}}
              </strong>
            </div>

            <div v-show="cliente.mostrarDetalhes">

              <div class="w3-col s12 tamanho-fonte-detalhes w3-right" style="padding-bottom: 0px;">
                <label>{{cliente.tipo_cliente_analitico}}</label>
              </div>

              <div class="w3-col s12 tamanho-fonte-detalhes" style="margin-bottom: 5px;">
                <legenda>
                  <div>Endereço</div>
                  <i slot="referencia" style="color: #31607d;" class="fa fa-map-marked-alt"></i>
                </legenda>
                <label 
                  @click="abrirMapa(cliente.cep)"
                  :class="getStyleEndereco(cliente.cep)">
                  {{cliente.nome_cidade}} / {{cliente.nome_bairro}} / {{cliente.logradouro}}
                </label>
              </div>

              <div class="w3-col s12 tamanho-fonte-detalhes" style="padding-bottom: 0px;">
                <label>Limite crédito: {{cliente.limite_credito_aprovado}}</label>
              </div>

              <div class="w3-col s12 tamanho-fonte-detalhes" style="padding-bottom: 0px;">
                <label>Limite disponível: {{cliente.limite_credito_disponivel}}</label>
              </div>

              <div class="w3-col s12 tamanho-fonte-detalhes">

                <div class="w3-col s12" style="margin-bottom: 5px; color: #333333;">
                  <div style="border-bottom: 2px dotted #a3a3a3; margin-top:5px;" class="w3-col"></div>
                  <h6 
                    class="fundo-cabecalho-dados">
                    &nbsp;
                    <i class="fas fa-list-ul">
                    </i>&nbsp;
                    <strong> Opções </strong> 
                  </h6>
                  <div style="border-bottom: 2px dotted #a3a3a3;" class="w3-col"></div>
                </div>

                <div 
                  class="w3-col s6 m3 l1 w3-center" 
                  style="padding-top: 5px;" 
                  v-show="(roteiro_selecionado) && (cliente.roteiro_visitas_id == 0)">
                  <button 
                    title="Incluir no roteiro"
                    v-on:click="incluirItemRoteiroVisita(cliente)"
                    style="width:120px; font-weight: normal!important;"
                    class="w3-button cor-botao-incluir-roteiro">
                    <i class="fa fa-plus-circle"></i> Incluir
                  </button>
                </div>

                <div class="w3-col s6 m3 l1 w3-center" style="padding-top: 5px;" v-show="(roteiro_selecionado) && (roteiro_selecionado.status != 'BAI') && (cliente.status == 'PLA')">
                  <button 
                    title="Registrar check-in da visita"
                    v-on:click="registrarCheckIn(cliente)"
                    style="width:120px; font-weight: normal!important;"
                    class="w3-button cor-botao-check-in">
                    <i class="fa fa-map-marker-alt"></i> Check-In
                  </button>
                </div>

                <div 
                  class="w3-col s6 m3 l1 w3-center"
                  style="padding-top: 5px;" 
                  v-show="(roteiro_selecionado) && (roteiro_selecionado.status != 'BAI') && (cliente.status == 'PLA')">
                  <button 
                    title="Definir horário de agendamento"
                    v-on:click="incluirItemRoteiroVisita(cliente)"
                    style="width:120px; font-weight: normal!important;"
                    class="w3-button cor-botao-definir-horario">
                    <i class="fa fa-calendar-alt"></i> Horário
                  </button>
                </div>

                <div class="w3-col s6 m3 l1 w3-center" style="padding-top: 5px;" v-show="(roteiro_selecionado) && (roteiro_selecionado.status != 'BAI') && (cliente.status == 'EAN')">
                  <button 
                    title="Registrar check-out da visita"
                    v-on:click="exibirCheckOut(cliente)"
                    style="width:120px; font-weight: normal!important;"
                    class="w3-button cor-botao-check-out">
                    <i class="fa fa-map-marked-alt"></i> Check-Out
                  </button>
                </div>

                <div class="w3-col s6 m3 l1 w3-center" style="padding-top: 5px;" v-show="(roteiro_selecionado) && (cliente.roteiro_visitas_id > 0)">
                  <button 
                    v-on:click="exibirFotosVisita(cliente)"
                    title="Upload de fotos"
                    style="width:120px; font-weight: normal!important;"
                    class="w3-button cor-botao-upload-fotos">
                    <i class="fa fa-camera"></i> Fotos
                  </button>
                </div>

                <div class="w3-col s6 m3 l1 w3-center" style="padding-top: 5px;" v-show="(roteiro_selecionado) && (cliente.roteiro_visitas_id > 0)">
                  <button
                    title="Exibir observações"
                    v-on:click="exibirObservacao(cliente, 'VISITA')"
                    style="width:120px; font-weight: normal!important;"
                    class="w3-button cor-botao-upload-observacao">
                    <i class="fa fa-comment"></i> Observação
                  </button>
                </div>

                <div 
                  class="w3-col s6 m3 l1 w3-center"
                  style="padding-top: 5px;"
                  v-show="(roteiro_selecionado) && (roteiro_selecionado.status != 'BAI') && (cliente.roteiro_visitas_id > 0) && (cliente.status == 'PLA')">
                  <button 
                    title="Remover do roteiro"
                    v-on:click="removerClienteRoteiro(cliente)"
                    style="width:120px; font-weight: normal!important;"
                    class="w3-button cor-botao-remover-roteiro">
                    <i class="fa fa-minus-circle"></i> Excluir
                  </button>
                </div>



                <div class="w3-col s6 m3 l1 w3-center" style="padding-top: 5px;">
                  <button 
                    v-on:click="exibirFinanceirosAberto(cliente)"
                    title="Financeiros abertos"
                    style="width:120px; font-weight: normal!important;"
                    class="w3-button cor-botao-financeiro">
                    <i class="fa fa-money-check-alt"></i> Financeiros
                  </button>
                </div>

              </div>

              <div class="w3-col s12 tamanho-fonte-detalhes" v-show="cliente.roteiro_visitas_id > 0">

                <div class="w3-col s12" style="margin-bottom: 5px; color: #333333;">
                  <div style="border-bottom: 2px dotted #a3a3a3; margin-top:5px;" class="w3-col"></div>
                  <h6 
                    class="fundo-cabecalho-dados">
                    &nbsp;
                    <i class="fas fa-calendar-alt">
                    </i>&nbsp;
                    <strong> Dados da visita </strong> 
                  </h6>
                  <div style="border-bottom: 2px dotted #a3a3a3;" class="w3-col"></div>
                </div>

                <div class="w3-col s12 tamanho-fonte-detalhes" v-show="cliente.data_hora_prevista">
                  <label>Data/hora prevista: {{cliente.data_hora_prevista}} </label>
                </div>

                <div class="w3-col s12 tamanho-fonte-detalhes" v-show="cliente.data_hora_check_in">
                  <label>Check-in: {{cliente.data_hora_check_in}} </label>
                </div>

                <div class="w3-col s12 tamanho-fonte-detalhes" v-show="cliente.data_hora_check_out">
                  <label>Check-out: {{cliente.data_hora_check_out}} </label>
                </div>

                <div class="w3-col S12">
                  <legenda>
                    <div>Status da visita</div>
                    <i 
                      slot="referencia"
                      :style="getStyleStatusVisita(cliente.status)"
                      :class="getIconeStatus(cliente.status)">
                    </i>
                  </legenda>
                  <strong 
                    :style="getStyleStatusVisita(cliente.status)">
                    {{cliente.status_analitico}}
                  </strong>
                </div>

                <div class="w3-col S12">
                  <legenda>
                    <div>Resultado da visita</div>
                    <i 
                      slot="referencia" 
                      :style="getStyleResultado(cliente.resultado)"
                      :class="getIconeResultado(cliente.resultado)"
                    ></i>
                  </legenda>
                  <strong 
                    :style="getStyleResultado(cliente.resultado)">
                    {{cliente.resultado_analitico}}
                  </strong>
                </div>
              </div>

              <div class="w3-col s12 tamanho-fonte-detalhes" v-show="cliente.telefones && cliente.telefones.length > 0">

                <div class="w3-col s12" style="margin-bottom: 5px; color: #333333;">
                  <div style="border-bottom: 2px dotted #a3a3a3; margin-top:5px;" class="w3-col"></div>
                  <h6 
                    class="fundo-cabecalho-dados">
                    &nbsp;
                    <i class="fas fa-phone">
                    </i>&nbsp;
                    <strong> Contatos </strong> 
                  </h6>
                  <div style="border-bottom: 2px dotted #a3a3a3;" class="w3-col"></div>
                </div>
                
                <div 
                  :key="telefone.telefone"
                  v-for="(telefone) in cliente.telefones">
                  
                  <div class="w3-col s6" @click="abrirWhatsApp(telefone.telefone)">
                    <legenda>
                      <div>{{telefone.tipo_telefone_analitico}}</div>
                      <a 
                        slot="referencia"
                        style="text-decoration: blink;">
                        <strong><i class="fas fa-phone cor-icone-telefone"></i></strong>
                      </a>
                    </legenda>
                    <label style="text-decoration: underline;">
                      <a>{{telefone.telefone}}</a>
                    </label>
                  </div>
                </div>
              </div>    

              <div class="w3-col s12 tamanho-fonte-detalhes" v-show="cliente.ultimo_check_out">
                
                <div class="w3-col s12" style="margin-bottom: 5px; color: #333333;">
                  <div style="border-bottom: 2px dotted #a3a3a3; margin-top:5px;" class="w3-col"></div>
                  <h6 
                    class="fundo-cabecalho-dados">
                    &nbsp;
                    <i class="fas fa-map-marked-alt">
                    </i>&nbsp;
                    <strong> Último check-out </strong> 
                  </h6>
                  <div style="border-bottom: 2px dotted #a3a3a3;" class="w3-col"></div>
                </div>

                <div class="w3-col s12 tamanho-fonte-detalhes">
                  <label>Check-in...: {{cliente.ultimo_check_out ? cliente.ultimo_check_out.data_hora_check_in : ''}} </label>
                </div>

                <div class="w3-col s12 tamanho-fonte-detalhes">
                  <label>Check-out: {{cliente.ultimo_check_out ? cliente.ultimo_check_out.data_hora_check_out : ''}} </label>
                </div>

                <div class="w3-col s12" style="padding-top: 5px; padding-bottom: 5px;" v-show="(cliente.ultimo_check_out) && (cliente.ultimo_check_out.observacao)">
                  <button
                    title="Exibir observações"
                    v-on:click="exibirObservacao(cliente, 'ULTIMO_CHECK_OUT')"
                    style="width:150px; font-weight: normal!important;"
                    class="w3-button cor-botao-observacao-check-out">
                    <i class="fa fa-comment"></i> Ver observações
                  </button>
                </div>

              </div>

              <div class="w3-col s12 tamanho-fonte-detalhes" v-show="cliente.ultimos_pedidos_cliente && cliente.ultimos_pedidos_cliente.length > 0">

                <div style="border-bottom: 2px dotted #a3a3a3; margin-top:5px;" class="w3-col"></div>
                <h6 
                  class="fundo-cabecalho-dados">
                  &nbsp;
                  <i style="color: #333333;" class="fas fa-chart-line">
                  </i>&nbsp;
                  <strong style="color: #333333;"> Últimos 3 pedidos </strong> 
                </h6>
                <div style="border-bottom: 2px dotted #a3a3a3;" class="w3-col"></div>
                <div style="margin-bottom: 15px;" />

                <div class="card-item w3-border w3-container" :key="pedido.orcamento_id" v-for="(pedido) in cliente.ultimos_pedidos_cliente">
                  
                  <div class="w3-col">
                    <legenda>
                      <div>Pedido</div>
                      <i slot="referencia" class="fa fa-shopping-cart cor-icone-pedido"></i>
                    </legenda>
                    <strong>{{pedido.orcamento_id}}</strong>
                  </div>

                  <div class="w3-col">
                    <legenda>
                      <div>Vendedor</div>
                      <i slot="referencia" class="fa fa-user-tag cor-icone-vendedor"></i>
                    </legenda>
                    <label>{{pedido.nome_vendedor}}</label>
                  </div>

                  <div class="w3-col">
                    <legenda>
                      <div>Empresa</div>
                      <i slot="referencia" class="fa fa-building cor-icone-empresa"></i>
                    </legenda>
                    <label>{{pedido.empresa_id + ' - ' + pedido.nome_empresa}}</label>
                  </div>

                  <div v-show="pedido.data_hora_recebimento" class="w3-col">
                    <legenda>
                      <div>Data de recebimento</div>
                      <i slot="referencia" class="fa fa-calendar-plus cor-icone-pedido"></i>
                    </legenda>
                    <label>{{pedido.data_hora_recebimento}}</label>
                  </div>

                  <div class="w3-col">
                    <legenda>
                      <div>Condição de pagamento</div>
                      <i slot="referencia" class="fa fa-credit-card cor-icone-condicao"></i>
                    </legenda>
                    <label>{{pedido.nome_condicao}}</label>
                  </div>

                  <div class="w3-col">
                    <legenda>
                      <div>Valor total do pedido</div>
                      <i slot="referencia" class="fa fa-hand-holding-usd cor-icone-total-pedido"></i>
                    </legenda>
                    <strong style="color: #388f36">R$ {{pedido.valor_pedido}}</strong>
                  </div>

                  <div class="w3-col S12 w3-center" v-on:click="abrirDadosPedido(pedido.orcamento_id)">
                    <legenda>
                      <div>Visualizar pedido</div>
                      <i slot="referencia" class="fa fa-search cor-botao-visualizar-pedido"></i>
                    </legenda>
                  </div>

                </div>
              </div>
            </div>

          </div>

        </div>
      </div>

      <dados-orcamento
        v-if="mostrar_modal_dados_orcamento"
        :orcamento_dados="orcamento_detalhe"
        @close="mostrar_modal_dados_orcamento = false"
      />

      <financeiros-aberto-cliente
        ref="financeirosAbertoCliente"
      />

      <button 
        v-if="false"
        id="floating-button"
        v-on:click="novoRoteiro()"
        title="Atualizar carteira de clientes"  
        class="w3-button w3-theme w3-circle w3-display-bottomright" 
        style="border-radius: 50% !important">
        <i class="fa fa-sync-alt">
      </i></button>

      <div id="modalRoteiroVisita" class="w3-modal" v-if="mostrar_modal_roteiro" @click="mostrar_modal_roteiro = false" style="display: block">
        
        <div class="w3-modal-content w3-animate-zoom" @click.stop>
          
          <header class="w3-container">
            <span @click="mostrar_modal_roteiro = false" class="w3-button w3-display-topright">&times;</span>
            <h4 class="titulo texto-vermelho">Roteiro de Visita</h4>
          </header>
          
          <div class="w3-container">

            <div class="w3-row w3-col s12">
              <strong>Nome (opcional)</strong>
              <input 
                type="text" 
                maxlength="30" 
                class="w3-input" 
                placeholder="Nome" 
                onclick="this.select()"
                style="text-transform:uppercase"
                v-model="roteiro_edicao.nome"
              />
            </div>

            <div class="w3-row w3-col s12">
              <strong>Data inicial</strong>
              <input 
                type="date" 
                class="w3-input" 
                v-model="roteiro_edicao.data_inicial" 
                onkeyup="FormataDataDiaMesAno(this,'##/##/####',event)"
              />
            </div>

            <div class="w3-row w3-col s12">
              <strong>Data final</strong>
              <input 
                type="date"
                class="w3-input"  
                v-model="roteiro_edicao.data_final" 
                onkeyup="FormataDataDiaMesAno(this,'##/##/####',event)"
              />
            </div>

            <div class="w3-row w3-col s12" v-show="(roteiro_edicao.replicar != 'NEN') || valorInt(roteiro_edicao.roteiro_visitas_id) == 0">
              <strong>Replicar: </strong>
              <select 
                class="w3-select w3-border"
                v-model="roteiro_edicao.replicar" 
                @change="configurarQtdVezesReplicar"
                :disabled="valorInt(roteiro_edicao.roteiro_visitas_id) > 0">
                <option value="NEN" default>Nenhum</option>
                <option value="SEM" >Semanalmente </option>
                <option value="QUI">Quinzenalmente</option>
                <option value="MEN">Mensalmente</option>
              </select>
            </div>

            <div class="w3-row w3-col s12" v-show="roteiro_edicao.replicar != 'NEN'">
              <strong class="w3-block">Qtd. de vezes replicar</strong>
              <input 
                type="number"
                maxlength="3" 
                class="w3-input w3-border"
                v-model="roteiro_edicao.qtd_vezes_replicar"
                :disabled="valorInt(roteiro_edicao.roteiro_visitas_id) > 0"
              />
            </div>

            <div class="w3-col s12" v-if="roteiro_edicao.copia_roteiro_visitas_id > 0">
              <h6 
                class="fundo-cabecalho-copiando-roteiro">
                &nbsp;
                <i class="fas fa-paste">
                </i>&nbsp;&nbsp;&nbsp;
                <a> Copiando roteiro: {{roteiro_edicao.copia_roteiro_visitas_id}}</a> 
              </h6>

              <label 
                class="w3-center tamanho-fonte-detalhes">
                Todas a visitas do roteiro {{formatarValor(roteiro_edicao.copia_roteiro_visitas_id, 0)}} serão copiadas com o status em planejamento.
              </label>
            </div>
            
          </div>

          <footer class="w3-container w3-center w3-margin-top">

            <button 
              title="Gravar roteiro"
              v-on:click="gravarRoteiro()"
              class="w3-button w3-theme">
              <i class="fa fa-check-circle"></i>  Confirmar
            </button>
          
          </footer>
        
        </div>
      
      </div>
      <!-- Fim modal de roteiro -->

      <!-- Inicio modal opções proposta de orçamento -->
      <div id="modalOpcoesBloqueioProposta" class="w3-modal" v-if="mostrar_modal_opcoes_excluir_roteiro" @click="mostrar_modal_opcoes_excluir_roteiro = false" style="display: block">
        <div class="w3-modal-content w3-animate-zoom" @click.stop>
          <header class="w3-container">
            <h5 class="titulo texto-vermelho">Opções de exclusão do roteiro</h5>
            <span @click="mostrar_modal_opcoes_excluir_roteiro = false" class="w3-button w3-display-topright">&times;</span>
          </header>

          <div class="w3-row-padding">
            <div class="w3-responsive">

              <div class="w3-padding-small" @click="tipo_exclusao_roteiro_replicado = 'T'">
                <span>
                  <i class="far fa-circle" v-if="tipo_exclusao_roteiro_replicado != 'T'"></i>
                  <i class="far fas fa-check-circle" style="color: #199436;" v-if="tipo_exclusao_roteiro_replicado == 'T'"></i>
                  &nbsp;Excluir roteiro selecionado e todos os roteiros replicados com status (Em aberto)
                </span>
              </div>

              <div class="w3-padding-small" @click="tipo_exclusao_roteiro_replicado = 'M'">
                <span>
                  <i class="far fa-circle" v-if="tipo_exclusao_roteiro_replicado != 'M'"></i>
                  <i class="far fas fa-check-circle" style="color: #199436;" v-if="tipo_exclusao_roteiro_replicado == 'M'"></i>
                  &nbsp;Excluir somente o roteiro selecionado mas manter os roteiros replicados
                </span>
              </div>

            </div>

            <div class="w3-center w3-col s12" style="margin-top: 5px; margin-bottom:5px">
              <button 
                class="w3-button w3-theme" 
                v-on:click="excluirRoteiro(roteiro_selecionado, false)"> 
                <i class="fas fa-check-circle"></i> Ok
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Fim do modal oções de desconto -->

      <div id="modalItemRoteiroVisita" class="w3-modal" v-if="mostrar_modal_item_roteiro" @click="mostrar_modal_item_roteiro = false" style="display: block">
        
        <div class="w3-modal-content w3-animate-zoom" @click.stop>
          
          <header class="w3-container">
            <span @click="mostrar_modal_item_roteiro = false" class="w3-button w3-display-topright">&times;</span>
            <h4 class="titulo texto-vermelho">Item Roteiro de Visita</h4>
          </header>
          
          <div class="w3-container">

            <div class="w3-col S12">
              <legenda>
                <div>Cliente</div>
                <i slot="referencia" class="fas fa-user-alt texto-vermelho"></i>
              </legenda>
              <strong>{{this.formatarValor(item_roteiro_edicao.cadastro_id, 0) + '-' + item_roteiro_edicao.nome_fantasia}}</strong>
            </div>

            <div class="w3-col s12">
              <h6 
                class="fundo-cabecalho-cinza">
                &nbsp;
                <i class="fas fa-calendar-plus">
                </i>&nbsp;&nbsp;&nbsp;
                <a > Data/hora prevista</a> 
              </h6>
            </div>

            <div class="w3-col s7">
              <input 
                type="date"
                class="w3-input"  
                v-model="item_roteiro_edicao.data_prevista" 
              />
            </div>

            <div class="w3-col s4" style="margin-left:15px;">
              <input 
                type="time" 
                class="w3-input"   
                v-model="item_roteiro_edicao.hora_prevista" 
              />
            </div>

          </div>

          <footer class="w3-container w3-center" style="margin-top: 15px;">

            <button 
              title="Gravar item no roteiro"
              v-on:click="atualizarItemRoteiroVisita()"
              class="w3-button w3-theme">
              <i class="fa fa-check-circle"></i> Confirmar
            </button>
          
          </footer>
        </div>
      </div>

      <div id="modalCheckOut" class="w3-modal" v-if="mostrar_modal_check_out" @click="mostrar_modal_check_out = false" style="display: block">
        
        <div class="w3-modal-content w3-animate-zoom" @click.stop>
          
          <header class="w3-container">
            <span @click="mostrar_modal_check_out = false" class="w3-button w3-display-topright">&times;</span>
            <h4 class="titulo texto-vermelho">Check-Out da Visita</h4>
          </header>
          
          <div class="w3-container">

            <div class="w3-col S12">
              <legenda>
                <div>Cliente</div>
                <i slot="referencia" class="fas fa-user-alt texto-vermelho"></i>
              </legenda>
              <strong>{{this.formatarValor(item_roteiro_edicao.cadastro_id, 0) + '-' + item_roteiro_edicao.nome_fantasia}}</strong>
            </div>

            <div class="w3-col s12">
              <h6 
                class="fundo-cabecalho-cinza">
                &nbsp;
                <i class="fas fa-poll">
                </i>&nbsp;
                <a> Resultado da visita</a> 
              </h6>
            </div>

            <div class="w3-col s12">
              <select 
                class="w3-select w3-border"
                v-model="tipo_resultado">
                <option value="NDE">Năo definido</option>
                <option value="POS">Positivado</option>
                <option value="EST">Estocado</option>
                <option value="PRE">Preço alto</option>
                <option value="INA">Inadimplente</option>
                <option value="LIM">Limite indisponível</option>
                <option value="EXC">Exclusivo do concorrente</option>
                <option value="NAO">Năo visitado</option>
                <option value="OUT">Outros</option>
              </select>
            </div>

            <div class="w3-col s12" style="padding-left: 10px; padding-bottom: 0px; padding-top: 5px;">
              <i :class="getIconeResultado(tipo_resultado)"/>
              <label v-show="tipo_resultado == 'NDE'" class="fonte-resultado">Resultado não definido</label>
              <label v-show="tipo_resultado == 'POS'" class="fonte-resultado">Cliente fez pedido na visita</label>
              <label v-show="tipo_resultado == 'EST'" class="fonte-resultado">Cliente não fez pedido pois já tem estoque para os próximos dias</label>
              <label v-show="tipo_resultado == 'PRE'" class="fonte-resultado">Cliente não fez pedido pois o preço está alto</label>
              <label v-show="tipo_resultado == 'INA'" class="fonte-resultado">Cliente tem título financeiro em aberto em atraso</label>
              <label v-show="tipo_resultado == 'LIM'" class="fonte-resultado">Cliente não tem limite de crédito disponível para realizar um novo pedido</label>
              <label v-show="tipo_resultado == 'EXC'" class="fonte-resultado">Cliente não tem interesse de adquirir mercadorias da empresa</label>
              <label v-show="(tipo_resultado == 'NAO') || (tipo_resultado == 'OUT')" class="fonte-resultado">Obrigatória a observação.</label>
            </div>

            <div class="w3-col s12">
              <h6 
                class="fundo-cabecalho-cinza">
                &nbsp;
                <i class="fas fa-comment-alt">
                </i>&nbsp;
                <a > Observações</a> 
              </h6>
            </div>

            <div class="w3-col s12">
              <textarea 
                class="w3-border" 
                style="width:100%; font-size:13px;"
                v-model="item_roteiro_edicao.observacao" 
                rows="5"
              />
            </div>
          </div>

          <footer class="w3-container w3-center">

            <button 
              title="Registrar check-out da visita"
              v-on:click="registrarCheckOut()"
              class="w3-button w3-theme">
              <i class="fa fa-check-circle"></i>  Confirmar
            </button>
          
          </footer>
        
        </div>
      
      </div>

      <div id="modalObservacao" class="w3-modal" v-if="mostrar_modal_observacao" @click="mostrar_modal_observacao = false" style="display: block">
        
        <div class="w3-modal-content w3-animate-zoom" @click.stop>
          
          <header class="w3-container">
            <span @click="mostrar_modal_observacao = false" class="w3-button w3-display-topright">&times;</span>
            <h4 class="titulo texto-vermelho">Observações da Visita</h4>
          </header>
          
          <div class="w3-container">

            <div class="w3-col S12">
              <legenda>
                <div>Cliente</div>
                <i slot="referencia" class="fas fa-user-alt texto-vermelho"></i>
              </legenda>
              <strong>{{this.formatarValor(item_roteiro_edicao.cadastro_id, 0) + '-' + item_roteiro_edicao.nome_fantasia}}</strong>
            </div>

            <div class="w3-col s12" style="margin-top: 10px;">
              <textarea 
                rows="14"
                class="w3-border" 
                style="width:100%; font-size:13px;"
                v-model="item_roteiro_edicao.observacao" 
                :readonly="
                  (!roteiro_selecionado) || 
                  (roteiro_selecionado.status == 'BAI') || 
                  (roteiro_selecionado.roteiro_visitas_id != item_roteiro_edicao.roteiro_visitas_id)"
                />
            </div>
          </div>

          <footer class="w3-container w3-center">

            <button 
              class="w3-button w3-theme"
              v-on:click="salvarObservacao()"
              title="Registrar check-out da visita"
              v-show="
                (roteiro_selecionado) && 
                (roteiro_selecionado.status != 'BAI') && 
                (roteiro_selecionado.roteiro_visitas_id == item_roteiro_edicao.roteiro_visitas_id)"
              >
              <i class="fa fa-check-circle"></i> Confirmar
            </button>
          
          </footer>
        
        </div>
      
      </div>

      <div id="modalFotosVisita" class="w3-modal" v-if="mostrar_modal_fotos_visita" @click="mostrar_modal_fotos_visita = false" style="display: block; padding-top: 30px;">
        
        <div class="w3-modal-content w3-container w3-animate-zoom" @click.stop>
          
          <header>
            <span @click="mostrar_modal_fotos_visita = false" class="w3-button w3-display-topright">&times;</span>
            <h4 class="titulo texto-vermelho">Fotos da Visita</h4>
          </header>

          <div class="w3-margin-bottom" style="max-height: calc(80vh - 80px); min-height: 200px; overflow: auto">

            <div class="w3-responsive w3-col 12">
              <input
                type="file"
                id="ifotos"
                accept=".jpg"
                class="fotos"
                v-show="false"
                v-on:change="lerArquivo()">

              <div class="w3-center imagemCentralizada">
                <div class="w3-col s12 m3 l3">
                  <div class="w3-margin">
                    <header class="w3-container w3-col foto-cabecalho" style="position:relative;">
                    <span 
                      v-show="(roteiro_selecionado.status != 'BAI')"
                      v-on:click="limparFoto(0)" 
                      class="w3-button w3-display-topright">
                      &times;
                    </span>
                    </header>
                    <img id="img01" class="imagem" @click="adicionarFoto('1')" :src="fotoPadrao"/>
                    <label 
                      class="w3-right"
                      style="font-size: 11px;"
                      v-show="data_hora_envio_foto_0 != ''">
                      Data/hora envio: {{data_hora_envio_foto_0}}  
                    </label>
                    <input 
                      type="text"
                      id="txtTitulo01"
                      v-model="titulo_foto_0"
                      onclick="this.select()"
                      v-on:keyup="upperCase('txtTitulo01')"
                      placeholder="Título da foto"
                      style="margin-top: 10px;"
                      :readonly="roteiro_selecionado.status == 'BAI'"
                      class="w3-input"
                    />
                  </div>
                </div>

                <div class="w3-col s12 m3 l3">
                  <div class="w3-margin">
                    <header class="w3-container w3-col foto-cabecalho" style="position:relative;">
                    <span 
                      v-show="(roteiro_selecionado.status != 'BAI')" 
                      v-on:click="limparFoto(1)" 
                      class="w3-button w3-display-topright">
                      &times;
                    </span>
                    </header>
                    <img id="img02" class="imagem" @click="adicionarFoto('2')" :src="fotoPadrao"/>
                    <label 
                      class="w3-right" 
                      style="font-size: 11px;"
                      v-show="data_hora_envio_foto_1 != ''">
                      Data/hora envio: {{data_hora_envio_foto_1}}  
                    </label>
                    <input 
                      type="text"
                      id="txtTitulo02"
                      onclick="this.select()"
                      v-model="titulo_foto_1"
                      v-on:keyup="upperCase('txtTitulo02')"
                      placeholder="Título da foto"
                      style="margin-top: 10px;"
                      :readonly="roteiro_selecionado.status == 'BAI'"
                      class="w3-input"
                    />
                  </div>
                </div>

                <div class="w3-col s12 m3 l3">
                  <div class="w3-margin">
                    <header class="w3-container w3-col foto-cabecalho" style="position:relative;">
                    <span 
                      v-show="(roteiro_selecionado.status != 'BAI')"
                      v-on:click="limparFoto(2)" 
                      class="w3-button w3-display-topright">
                      &times;
                    </span>
                    </header>
                    <img id="img03" class="imagem" @click="adicionarFoto('3')" :src="fotoPadrao"/>
                    <label 
                      class="w3-right"
                      style="font-size: 11px;"
                      v-show="data_hora_envio_foto_2 != ''">
                      Data/hora envio: {{data_hora_envio_foto_2}}  
                    </label>
                    <input 
                      type="text"
                      id="txtTitulo03"
                      v-model="titulo_foto_2"
                      onclick="this.select()"
                      v-on:keyup="upperCase('txtTitulo03')"
                      placeholder="Título da foto"
                      style="margin-top: 10px;"
                      :readonly="roteiro_selecionado.status == 'BAI'"
                      class="w3-input"
                    />
                  </div>
                </div>

                <div class="w3-col s12 m3 l3">
                  <div class="w3-margin">
                    <header class="w3-container w3-col foto-cabecalho" style="position:relative;">
                    <span 
                      v-show="(roteiro_selecionado.status != 'BAI')" 
                      v-on:click="limparFoto(3)" 
                      class="w3-button w3-display-topright">
                      &times;
                    </span>
                    </header>
                    <img id="img04" class="imagem" @click="adicionarFoto('4')" :src="fotoPadrao"/>
                    <label 
                      class="w3-right"
                      style="font-size: 11px;"
                      v-show="data_hora_envio_foto_3 != ''">
                      Data/hora envio: {{data_hora_envio_foto_3}}  
                    </label>
                    <input 
                      type="text"
                      id="txtTitulo04"
                      v-model="titulo_foto_3"
                      onclick="this.select()"
                      v-on:keyup="upperCase('txtTitulo04')"
                      placeholder="Título da foto"
                      style="margin-top: 10px;"
                      :readonly="roteiro_selecionado.status == 'BAI'"
                      class="w3-input"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <footer class="w3-container w3-center">
            <button 
              class="w3-button w3-theme"
              v-on:click="enviarFotosVisita()"
              title="Registrar fotos da visita"
              v-show="(roteiro_selecionado.status != 'BAI')">
              <i class="fa fa-cloud-upload-alt"></i>
              Upload
            </button>
          </footer>

        </div>
      </div>

      <div id="modalProcessando" class="w3-modal" style="display: block;" v-if="processando">
        <div class="w3-modal-content w3-border" style="background-color: rgb(197, 197, 197); margin-top:25%; padding: 0px">
          <div class="w3-container w3-panel">
            <center style="margin-top:0; padding-top:0px">
              <div style="margin-top:0; padding-top:0px;" class="carregando"/>
              <div>
                <strong class="w3-text-theme">
                  <h6>{{descricao_processando_fotos}}</h6>
                </strong>
              </div>
            </center>
          </div>
        </div>
      </div>
     
    </div>
  </div>
</template>

<script>
  import moment from 'moment'  
  import legenda from '@/components/Legendas'
  import NavMenu from '@/components/Menu'
  import formatarValorMixin from '@/mixins/formatarValorMixin'
  import Biblioteca from '@/components/Repositorio/Biblioteca.js'
  import RCliente from '@/components/Rest/RCliente/RCliente.js'
  import RRoteiro from '@/components/Rest/RRoteiro.js'
  import DadosOrcamento from '@/components/Orcamentos/DadosOrcamento'
  import FinanceirosAbertoCliente from '@/components/FinanceirosAbertoCliente'

  export default {
    name: "CarteiraCliente",
    components: {
      legenda, 
      NavMenu,
      DadosOrcamento, 
      FinanceirosAbertoCliente
    },
    mixins:[formatarValorMixin],
    data() {
      return {
        aba_selecionada: 'carteira',
        clientes_carteira: [],
        clientes_carteira_aux: [],
        orcamento_detalhe: undefined,
        mostrar_modal_dados_orcamento: false,
        mostrar_mais_botoes: false,
        mostrar_modal_roteiro: false,
        mostrar_modal_check_out: false,
        mostrar_modal_observacao: false,
        mostrar_modal_item_roteiro: false,
        mostrar_modal_fotos_visita: false,
        mostrar_modal_opcoes_excluir_roteiro: false,
        fotoPadrao: "/static/imagens/ImagemAdicionar.png",
        processando: false,
        descricao_processando_fotos: '',
        roteiro_selecionado: undefined,
        roteiro_edicao: {},
        item_roteiro_edicao: {},
        tipo_resultado: '',
        titulo_foto_0: '',
        titulo_foto_1: '',
        titulo_foto_2: '',
        titulo_foto_3: '',
        data_hora_envio_foto_0: '',
        data_hora_envio_foto_1: '',
        data_hora_envio_foto_2: '',
        data_hora_envio_foto_3: '',
        aut_criar_alterar_roteiros_visitas: undefined,
        aut_alterar_excluir_roteiros_visitas_ja_iniciados: undefined,
        aut_excluir_fotos_roteiros_visitas: undefined,
        tipo_exclusao_roteiro_replicado: 'N',

        mostrar_modal: false,
        data_inicio:'',
        data_final:'',
        hora_inicio:'',
        hora_final:'',
        nome:'',
        roteiros:[],
        roteiros_aux:[],
      }
    },
    methods: {
      async reprocessar(){
        this.buscarAutorizacoes();
        this.buscarRoteirosVisitas();
      },

      async buscarRoteirosVisitas(){
        try {
          let parametros = {};

          let retorno = await RRoteiro.buscarRoteirosVisitas(this.axios, parametros);

          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }

          this.roteiros = retorno.dados;
        } catch (error) {
          let mensagem = Biblioteca.tratamentoMensagem(error);
          Biblioteca.exclamar(mensagem);  
        }
      },

      getStyleBotaoAbas(aba){
        if (this.aba_selecionada == aba){
          return "width: 98%; cursor:pointer; font-size: 16.2px; text-decoration: underline; "
        } else{
          return "width: 98%; cursor:pointer; font-size: 15px;"
        }
      },

      getPeriodoRoteiro(data_inicial, data_final){
        if (data_inicial === data_final) {
          return 'Data: ' + data_inicial;
        } else {
          return 'Período: ' + data_inicial + ' até ' + data_final;
        }
      },

      getPercentualConcluido(percentual_concluido){
        percentual_concluido = parseInt(percentual_concluido);

        if (percentual_concluido < 15){
          return 'width:15%'
        } else {
          return 'width:' + percentual_concluido + '%'
        }
      },

      getStylePercentualConcluido(percentual_concluido){
        percentual_concluido = parseInt(percentual_concluido);

        if (percentual_concluido <= 15){
          return 'w3-container w3-round w3-red'
        } else if (percentual_concluido <= 35){
          return 'w3-container w3-round w3-deep-orange'
        } else if (percentual_concluido <= 49){
          return 'w3-container w3-round w3-deep-purple'
        } else if (percentual_concluido <= 80){
          return 'w3-container w3-round w3-blue'
        } else if (percentual_concluido <= 99){
          return 'w3-container w3-round w3-teal'
        } else if (percentual_concluido == 100){
          return 'w3-container w3-round w3-green'
        }
      },

      getStyleFundoRoteiro(roteiro){
        if (!roteiro){
          return;
        }

        let style = "padding-bottom: 0px;";

        if (roteiro.mostrarDetalhes) {
          style = style + "border: 1px solid #bfbfbf; box-shadow: #7a7a7a 1px 2px 5px 2px;";
        }

        if (roteiro.status == 'BAI'){
          style = style + "background-color: #dedede; padding-bottom: 0px;"
        } else if (this.roteiro_selecionado && (roteiro.roteiro_visitas_id == this.roteiro_selecionado.roteiro_visitas_id)) {
          style = style + "background-color: #eaebd1; padding-bottom: 0px; box-shadow: #7a7a7a 1px 2px 5px 2px;"
        } 

        return style;
      },

      getStyleStatusRoteiro(status){
        if (status == 'ABE'){
          return "color: #5c9c60;"
        } 
        else if (status == 'PRO'){ 
          return "color: #31607d;"
        } 
        else if (status == 'BAI'){ 
          return "color: #805653;"
        }  
      },

      getIconeStatus(status){
        if (status == 'PLA'){
          return "fa fa-route texto-vermelho";
        }
        else if (status == 'EAN'){
          return "fa fa-road texto-vermelho";
        }
        else if (status == 'FIN'){
          return "fa fa-map-marker-alt texto-vermelho";
        }
      },

      getStyleResultado(resultado){
        if (resultado == 'NDE'){
          return "color: #b35959;";
        }
        else if (resultado == 'POS'){
          return "color: #a3557f;";
        } 
        else if (resultado == 'EST'){
          return "color: #7f9ed4;";
        }
        else if (resultado == 'PRE'){
          return "color: #56967b;";
        }
        else if (resultado == 'INA'){
          return "color: #759656;";
        }
        else if (resultado == 'LIM'){
          return "color: #63a873;";
        }
        else if (resultado == 'EXC'){
          return "color: #cca36e;";
        }
        else if (resultado == 'NAO'){
          return "color: #5b88b0;";
        }
        else if (resultado == 'OUT'){
          return "color: #91b05b;"; 
        }
      },

      getIconeResultado(resultado){
        if (resultado == 'NDE'){
          return "fa fa-question-circle";
        }
        else if (resultado == 'POS'){
          return "fa fa-shopping-cart";
        } 
        else if (resultado == 'EST'){
          return "fa fa-dolly";
        }
        else if (resultado == 'PRE'){
          return "fa fa-comment-dollar";
        }
        else if (resultado == 'INA'){
          return "fa fa-user-lock";
        }
        else if (resultado == 'LIM'){
          return "fa fa-credit-card";
        }
        else if (resultado == 'EXC'){
          return "fa fa-id-card-alt";
        }
        else if (resultado == 'NAO'){
          return "fa fa-user-slash";
        }
        else if (resultado == 'OUT'){
          return "fa fa-info-circle";
        }
      },

      async alternarDetalhesVisita(index){
        try{
          if (!this.roteiros[index].buscou_dados_complementares){
            let parametros = {
              roteiro_visitas_id: this.roteiros[index].roteiro_visitas_id 
            }

            let retorno = await RRoteiro.buscarItensRoteirosVisitas(this.axios, parametros);

            if (retorno.houve_erro == 'S'){
              throw new Error(retorno.mensagem);
            }

            this.roteiros[index].itens_roteiro = retorno.dados;
          }

          this.roteiros[index].mostrarListaVisita = true;
          this.roteiros[index].mostrarDetalhes = this.roteiros[index].mostrarDetalhes ? false : true;
          this.$forceUpdate();
        } catch (error) {
          let mensagem = Biblioteca.tratamentoMensagem(error);
          Biblioteca.exclamar(mensagem);  
        }
      },

      async mostrarListaVisita(index){
        try{
          this.roteiros[index].mostrarListaVisita = this.roteiros[index].mostrarListaVisita ? false : true;
          this.$forceUpdate();
        } catch (error) {
          let mensagem = Biblioteca.tratamentoMensagem(error);
          Biblioteca.exclamar(mensagem);  
        }
      },

      async selecionarRoteiro(roteiro){
        try {
          if (!roteiro) {
            Biblioteca.exclamar('Nenhum roteiro foi selecionado.');  
            return;
          }

          this.processando = true;

          if (this.roteiro_selecionado && (this.roteiro_selecionado.roteiro_visitas_id == roteiro.roteiro_visitas_id)){
            this.limparRoteiroSelecionado();
          } else{
            await this.adicionarRoteiro(roteiro);
            this.aba_selecionada = 'carteira';
          }

          this.processando = false;
        } catch (error) {
          this.verificarErro(error, 'selecionarRoteiro');
        }
      },

      abrirOrcamentoCliente(cadastro_id) {
        return '/vendas/orcamentos/{"cadastro_id":' + cadastro_id + '}'
      },

      tratarNumeroTelefone(telefone){
        telefone = telefone.replace("-","");
        telefone = telefone.replace(" ","");
        telefone = telefone.replace("(", '');
        telefone = telefone.replace(")", '');
          return telefone;
      },
      
      abrirMapa(cep){
        if (!cep){
          return;
        }

        try {
          swal(
            "Deseja abrir o endereço no Google maps?", 
            {
              buttons: {
                sim: "Sim",
                nao: "Não"                
              },
            }
          ).then((value) => {
            switch (value) {
              case "sim":
             
              if (cep){
                window.open("https://www.google.com/maps/search/?api=1&query=" + cep,'_blank');
              }

              break;
            }
          });
        } catch (error) {
          this.verificarErro(error, 'abrirMapa');   
        }
      },

      async abrirWhatsApp(telefone){
        if (!telefone){
          return;
        }

        try {
          await swal(
            "O que deseja fazer com o número: " + telefone + "?", 
            {
              buttons: {
                whats:  "Abrir WhatsApp",
                ligar:  "Fazer Ligação",
                nenhum: "Nenhum"                 
              },
            }
          ).then(async (value) => {

            telefone = await this.tratarNumeroTelefone(telefone);
            
            switch (value) {
              case "whats":
              window.open("https://api.whatsapp.com/send?phone=" + telefone + "6&text&source&data",'_blank');
              
              case "ligar":
              window.open("tel:$" + telefone);

              break;
            }

          });
        } catch (error) {
          this.verificarErro(error, 'abrirMapa');   
        }
      },

      exibirMenuRoteiro(){
        if (
          this.mostrar_modal_dados_orcamento ||
          this.mostrar_modal_roteiro ||
          this.mostrar_modal_check_out ||
          this.mostrar_modal_observacao ||
          this.mostrar_modal_item_roteiro ||
          this.mostrar_modal_fotos_visita
        ){
          return false;
        } else{
          return true;
        }
      },
  
      async buscarRoteiroMaisRelevante(){
        try {
          this.processando = true;
          let parametros = {};

          let retorno = await RRoteiro.buscarRoteiroMaisRelevante(this.axios, parametros);

          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }

          this.roteiro_selecionado = retorno.dados;
          await this.buscarRoteirosVisitas();

          this.processando = false;
        } catch (error) {
          this.verificarErro(error, 'buscarRoteiroMaisRelevante');
        }    
      },

      async buscarAutorizacoes(){
        try {
          this.processando = true;
          let parametros = {};

          let retorno = await RRoteiro.buscarAutorizacoes(this.axios, parametros);

          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }

          this.aut_criar_alterar_roteiros_visitas = retorno.dados.criar_alterar_roteiros_visitas;
          this.aut_alterar_excluir_roteiros_visitas_ja_iniciados = retorno.dados.alterar_excluir_roteiros_visitas_ja_iniciados;
          this.aut_excluir_fotos_roteiros_visitas = retorno.dados.excluir_fotos_roteiros_visitas;

          this.processando = false;
        } catch (error) {
          this.verificarErro(error, 'buscarAutorizacoes');
        }    
      },

      async buscarCarteiraClientes(roteiro_visitas_id){
        try {
          this.processando = true;

          let parametros = {
            roteiro_visitas_id: roteiro_visitas_id,
          }

          let retorno = await RCliente.buscarCarteiraClientes(this.axios, parametros);

          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }

          this.clientes_carteira = retorno.dados;
          this.clientes_carteira_aux = retorno.dados;

          this.ajustarTituloCliente();
          this.processando = false;
        } catch (error) {
          this.verificarErro(error, 'buscarCarteiraClientes');
        }    
      },

      async alternarDetalhesCliente(index){
        try{

          if (!this.clientes_carteira[index].buscou_dados_complementares){
            this.processando = true;

            let parametros = {
              cadastro_id: this.clientes_carteira[index].cadastro_id,
              roteiro_visitas_id: (this.roteiro_selecionado ? this.roteiro_selecionado.roteiro_visitas_id : 0),
              limite_credito_aprovado: this.clientes_carteira[index].limite_credito_aprovado 
            }

            let retorno = await RCliente.buscarDadosComplementar(this.axios, parametros);

            if (retorno.houve_erro == 'S'){
              throw new Error(retorno.mensagem);
            }

            this.clientes_carteira[index].limite_credito_disponivel = retorno.dados.limite_credito_disponivel;
            this.clientes_carteira[index].ultimos_pedidos_cliente = retorno.dados.ultimos_pedidos_cliente;
            this.clientes_carteira[index].ultimo_check_out = retorno.dados.ultimo_check_out;
            this.clientes_carteira[index].telefones = retorno.dados.telefones;

            this.processando = false;
            this.clientes_carteira[index].buscou_dados_complementares = true;
          }

          this.clientes_carteira[index].mostrarDetalhes = this.clientes_carteira[index].mostrarDetalhes ? false : true;
          this.$forceUpdate();
        } catch (error) {
          this.verificarErro(error, 'alternarDetalhesCliente');   
        }
      },

      verificarDadosRoteiro(roteiro){
        if (!roteiro.data_inicial) {
          Biblioteca.exclamar('Data inicial não informada!');
          return false;
        }

        if (!roteiro.data_final) {
          Biblioteca.exclamar('Data final não informada!');
          return false;
        }

        let formato_data = 'DD-MM-YYYY';
        let data_valida = moment(moment(roteiro.data_inicial).format(formato_data), formato_data, true).isValid();

        if (!data_valida) {
          Biblioteca.exclamar('Data inicial inválida!');
          return false;
        }

        data_valida = moment(moment(roteiro.data_inicial).format(formato_data), formato_data, true).isValid();

        if (!data_valida) {
          Biblioteca.exclamar('Data final inválida!');
          return false;
        }

        return true;
      },

      configurarQtdVezesReplicar(){
        if (this.roteiro_edicao.replicar == 'NEN'){
          this.roteiro_edicao.qtd_vezes_replicar = 0;
        }

        this.$forceUpdate();
      },

      async gravarRoteiro(){
        try {
          this.roteiro_edicao.roteiro_visitas_id = this.roteiro_edicao.roteiro_visitas_id ? this.roteiro_edicao.roteiro_visitas_id : 0;
          this.roteiro_edicao.nome = this.roteiro_edicao.nome ? this.roteiro_edicao.nome.toUpperCase() : '';
          this.roteiro_edicao.status = this.roteiro_edicao.status ? this.roteiro_edicao.status : 'ABE';

          let novo_roteiro = (this.roteiro_edicao.roteiro_visitas_id == 0);

          if (!this.verificarDadosRoteiro(this.roteiro_edicao)) {
            return;
          }

          this.processando = true;

          let parametros = {
            roteiro_visitas_id: this.roteiro_edicao.roteiro_visitas_id,
            nome: this.roteiro_edicao.nome,
            data_inicial: moment(this.roteiro_edicao.data_inicial, 'YYYY/MM/DD').format('DD/MM/YYYY'),
            data_final: moment(this.roteiro_edicao.data_final, 'YYYY/MM/DD').format('DD/MM/YYYY'),
            replicar: this.roteiro_edicao.replicar,
            qtd_vezes_replicar: this.roteiro_edicao.qtd_vezes_replicar,
            status: this.roteiro_edicao.status,
            copia_roteiro_visitas_id: this.roteiro_edicao.copia_roteiro_visitas_id
          }

          let retorno = await RRoteiro.atualizarRoteiroVisita(this.axios, parametros);

          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }

          swal(
            'Operação realizada com sucesso.', 
            novo_roteiro ? 'Código do novo roteiro: ' + retorno.dados.roteiro_visitas_id : '', 
            "success"
          );
         
          this.roteiro_edicao.roteiro_visitas_id = retorno.dados.roteiro_visitas_id;
          this.roteiro_edicao.data_inicial = moment(this.roteiro_edicao.data_inicial, 'YYYY/MM/DD').format('DD/MM/YYYY');
          this.roteiro_edicao.data_final = moment(this.roteiro_edicao.data_final, 'YYYY/MM/DD').format('DD/MM/YYYY');

          this.buscarRoteirosVisitas();

          if (novo_roteiro || (this.roteiro_selecionado.roteiro_visitas_id == this.roteiro_edicao.roteiro_visitas_id)){
            await this.adicionarRoteiro(this.roteiro_edicao);
            
            if (novo_roteiro){
              this.trocarAba('carteira');
            }
          }

          this.roteiro_edicao = {};
          this.processando = false;
          this.mostrar_modal_roteiro = false;
        } catch (error) {
          this.verificarErro(error, 'atualizarRoteiroVisita');
        }
      },

      incluirItemRoteiroVisita(cliente){
        if (!cliente){
          Biblioteca.exclamar('Nenhum cliente foi selecionado!');
          return;
        }

        if (this.aut_criar_alterar_roteiros_visitas == 'N' && this.aut_alterar_excluir_roteiros_visitas_ja_iniciados == 'N'){
          Biblioteca.exclamar('Usuário não autorizado a alterar roteiro de visitas!');
          return;
        }

        if (this.aut_criar_alterar_roteiros_visitas == 'N' && this.roteiro_selecionado.status == 'ABE'){
          Biblioteca.exclamar('Usuário não autorizado a alterar roteiro de visitas que está em aberto!');
          return;
        }

        if (this.aut_alterar_excluir_roteiros_visitas_ja_iniciados == 'N' && this.roteiro_selecionado.status != 'ABE'){
          Biblioteca.exclamar('Usuário não autorizado a alterar roteiro de visitas que já foi iniciado!');
          return;
        }

        try {
          this.item_roteiro_edicao = {};
          
          this.item_roteiro_edicao.roteiro_visitas_id = cliente.roteiro_visitas_id;
          this.item_roteiro_edicao.visita_id = cliente.visita_id;
          this.item_roteiro_edicao.status = cliente.status ? cliente.status : 'PLA';
          this.item_roteiro_edicao.cadastro_id = cliente.cadastro_id;
          this.item_roteiro_edicao.nome_fantasia = cliente.nome_fantasia;
          this.item_roteiro_edicao.observacao = cliente.observacao;

          if (cliente.data_hora_prevista && (!cliente.data_hora_prevista.trim() == '')){
            this.item_roteiro_edicao.data_prevista = moment(cliente.data_hora_prevista, 'DD/MM/YYYY HH:mm').format('YYYY-MM-DD');
            this.item_roteiro_edicao.hora_prevista = moment(cliente.data_hora_prevista, 'DD/MM/YYYY HH:mm').format('HH:mm');
          } else{
            this.item_roteiro_edicao.data_prevista = moment(this.roteiro_selecionado.data_inicial, 'DD/MM/YYYY').format('YYYY-MM-DD');
          }

          this.mostrar_modal_item_roteiro = true;
          this.$forceUpdate();
        } catch (error) {
          this.item_roteiro_edicao = {};
          this.verificarErro(error, 'incluirItemRoteiroVisita');
        }
      },

      async verificarDadosItemRoteiro(item_roteiro){

        if (!item_roteiro.data_prevista) {
          Biblioteca.exclamar('Data prevista não informada!');
          return false;
        }

        if (!item_roteiro.hora_prevista) {
          Biblioteca.exclamar('Hora prevista não informada!');
          return false;
        }

        if (!moment(item_roteiro.data_prevista).isValid()) {
          Biblioteca.exclamar('Data prevista inválida!');
          return false;
        }

        let parametros = {
          roteiro_visitas_id: this.roteiro_selecionado.roteiro_visitas_id,
          cadastro_id: item_roteiro.cadastro_id,
          visita_id: item_roteiro.visita_id,
          data_hora_prevista: moment(item_roteiro.data_prevista, 'YYYY/MM/DD').format('DD/MM/YYYY') + ' ' + item_roteiro.hora_prevista
        }

        let retorno = await RRoteiro.verificacoesItemRoteiro(this.axios, parametros);

        if (retorno.houve_erro == 'S'){
          throw new Error(retorno.mensagem);
        }

        // Verificando se o cliente já está no roteiro.
        let retorno_questionar_1 = true;
        if (retorno.dados.questionar_1){
          await swal(
            retorno.dados.questionar_1, 
            {
              buttons: {
                sim: "Sim",
                nao: "Não"                
              },
            }
          ).then((value) => {
            switch (value) {
              case "nao": 
                retorno_questionar_1 = false;
                break;
            }
          });
        }

        if(!retorno_questionar_1){
          return false;  
        }

        // Verificando se já existe data/horário igual cadastrado para outra visita.
        let retorno_questionar_2 = true; 
        if (retorno.dados.questionar_2){
          await swal(
            retorno.dados.questionar_2, 
            {
              buttons: {
                sim: "Sim",
                nao: "Não"                
              },
            }
          ).then((value) => {
            switch (value) {
              case "nao": 
                retorno_questionar_2 = false;
                break;
            }
          });
        }

        if(!retorno_questionar_2){
          return false;  
        }

        return true;
      },

      async atualizarItemRoteiroVisita(){
        try {
          
          if (!await this.verificarDadosItemRoteiro(this.item_roteiro_edicao)) {
           return;
          }

          //this.item_roteiro_edicao.data_prevista = moment(this.item_roteiro_edicao.data_prevista, 'YYYY/MM/DD').format('DD/MM/YYYY');
          this.processando = true;

          let parametros = {
            roteiro_visitas_id: this.roteiro_selecionado.roteiro_visitas_id,
            cadastro_id: this.item_roteiro_edicao.cadastro_id,
            visita_id: this.item_roteiro_edicao.visita_id,
            data_hora_prevista: moment(this.item_roteiro_edicao.data_prevista, 'YYYY/MM/DD').format('DD/MM/YYYY') + ' ' + this.item_roteiro_edicao.hora_prevista,
            observacao: this.item_roteiro_edicao.observacao,
            data_inicial_roteiro: this.roteiro_selecionado.data_inicial,
            data_final_roteiro: this.roteiro_selecionado.data_final
          }

          let retorno = await RRoteiro.atualizarItemRoteiroVisita(this.axios, parametros);

          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }
          
          await this.buscarRoteirosVisitas();
          
          this.item_roteiro_edicao = {};
          this.mostrar_modal_item_roteiro = false;
          this.processando = false;
        } catch (error) {
          this.verificarErro(error, 'atualizarItemRoteiroVisita');
        }
      },

      async removerClienteRoteiro(cliente){
        if (!cliente){
          Biblioteca.exclamar('Nenhum cliente foi selecionado!');
          return;
        }

        if (this.aut_criar_alterar_roteiros_visitas == 'N' && this.aut_alterar_excluir_roteiros_visitas_ja_iniciados == 'N'){
          Biblioteca.exclamar('Usuário não autorizado a alterar roteiro de visitas!');
          return;
        }

        if (this.aut_criar_alterar_roteiros_visitas == 'N' && this.roteiro_selecionado.status == 'ABE'){
          Biblioteca.exclamar('Usuário não autorizado a alterar roteiro de visitas que está em aberto!');
          return;
        }

        if (this.aut_alterar_excluir_roteiros_visitas_ja_iniciados == 'N' && this.roteiro_selecionado.status != 'ABE'){
          Biblioteca.exclamar('Usuário não autorizado a alterar roteiro de visitas que já foi iniciado!');
          return;
        }

        try {
          await swal(
            "Deseja remover o cliente " + 
            this.formatarValor(cliente.cadastro_id, 0) + '-' + cliente.nome_fantasia + 
            " do roteiro de visita selecionado?", {
              buttons: {
                sim: "Sim",
                nao: "Não"                
              },
            }
          ).then(async (value)=> {
            switch (value) {
              case "sim":

              this.processando = true;

              let parametros = {
                roteiro_visitas_id: cliente.roteiro_visitas_id,
                visita_id: cliente.visita_id
              }

              let retorno = await RRoteiro.excluirItemRoteiroVisitas(this.axios, parametros);

              if (retorno.houve_erro == 'S'){
                throw new Error(retorno.mensagem);
              }

              await this.buscarRoteirosVisitas();
              this.processando = false;

              break;
            }
          });
        } catch (error) {
          this.verificarErro(error, 'removerClienteRoteiro');   
        }
      },

      async registrarCheckIn(cliente){
        if (!cliente){
          Biblioteca.exclamar('Nenhum cliente foi selecionado!');
          return;
        }

        try {
          await swal(
            "Confirmar check-in no cliente " + 
            this.formatarValor(cliente.cadastro_id, 0) + '-' + cliente.nome_fantasia + "?", 
            {
              buttons: {
                sim: "Sim",
                nao: "Não"                
              },
            }
          ).then(async (value) => {
            switch (value) {
              case "sim":
              this.processando = true;

              let parametros = {
                roteiro_visitas_id: cliente.roteiro_visitas_id,
                visita_id: cliente.visita_id
              }

              let retorno = await RRoteiro.registrarCheckIn(this.axios, parametros);

              if (retorno.houve_erro == 'S'){
                throw new Error(retorno.mensagem);
              }

              await this.buscarRoteirosVisitas();
              this.processando = false;

              break;
            }
          });
        } catch (error) {
          this.verificarErro(error, 'registrarCheckIn');   
        }
      },

      async exibirCheckOut(cliente){
        if (!cliente){
          Biblioteca.exclamar('Nenhum cliente foi selecionado!');
          return;
        }

        try {
          this.item_roteiro_edicao = {};
          
          this.item_roteiro_edicao.roteiro_visitas_id = cliente.roteiro_visitas_id;
          this.item_roteiro_edicao.visita_id = cliente.visita_id;
          this.item_roteiro_edicao.cadastro_id = cliente.cadastro_id;
          this.item_roteiro_edicao.nome_fantasia = cliente.nome_fantasia;
          this.tipo_resultado = 'NDE';

          // Atualizando observação
          let parametros = {
            roteiro_visitas_id: cliente.roteiro_visitas_id,
            visita_id: cliente.visita_id
          }

          let retorno = await RRoteiro.buscarObservacao(this.axios, parametros);

          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }

          this.item_roteiro_edicao.observacao = retorno.dados; 
          this.mostrar_modal_check_out = true;
        } catch (error) {
          this.item_roteiro_edicao = {};
          this.verificarErro(error, 'exibirCheckOut');
        }
      },

      async exibirObservacao(cliente, tipo_observacao){
        if (!cliente){
          Biblioteca.exclamar('Nenhum cliente foi selecionado!');
          return;
        }

        try {
          this.item_roteiro_edicao = {};

          if (tipo_observacao == 'VISITA'){
            
            // Atualizando observação
            let parametros = {
              roteiro_visitas_id: cliente.roteiro_visitas_id,
              visita_id: cliente.visita_id
            }

            let retorno = await RRoteiro.buscarObservacao(this.axios, parametros);

            if (retorno.houve_erro == 'S'){
              throw new Error(retorno.mensagem);
            }

            this.item_roteiro_edicao.roteiro_visitas_id = cliente.roteiro_visitas_id;
            this.item_roteiro_edicao.visita_id = cliente.visita_id;
            this.item_roteiro_edicao.cadastro_id = cliente.cadastro_id;
            this.item_roteiro_edicao.nome_fantasia = cliente.nome_fantasia;

            this.item_roteiro_edicao.observacao = retorno.dados;
          } else if (tipo_observacao == 'ULTIMO_CHECK_OUT'){
            this.item_roteiro_edicao.cadastro_id = cliente.cadastro_id;
            this.item_roteiro_edicao.nome_fantasia = cliente.nome_fantasia;
            this.item_roteiro_edicao.observacao = cliente.ultimo_check_out.observacao;
          }

          this.mostrar_modal_observacao = true;
        } catch (error) {
          this.item_roteiro_edicao = {};
          this.verificarErro(error, 'exibirObservacao');
        }
      },

      async registrarCheckOut(){
        try {
          this.processando = true;

          let parametros = {
            roteiro_visitas_id: this.item_roteiro_edicao.roteiro_visitas_id,
            visita_id: this.item_roteiro_edicao.visita_id,
            resultado: this.tipo_resultado,
            observacao: this.item_roteiro_edicao.observacao
          }

          let retorno = await RRoteiro.registrarCheckOut(this.axios, parametros);

          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }

          await this.buscarRoteirosVisitas();

          this.mostrar_modal_check_out = false;            
          this.processando = false;
        } catch (error) {
          this.verificarErro(error, 'registrarCheckOut');   
        }
      },

       async salvarObservacao(){
        try {
          this.processando = true;

          let parametros = {
            roteiro_visitas_id: this.item_roteiro_edicao.roteiro_visitas_id,
            visita_id: this.item_roteiro_edicao.visita_id,
            observacao: this.item_roteiro_edicao.observacao
          }

          let retorno = await RRoteiro.salvarObservacao(this.axios, parametros);

          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }

          await this.buscarRoteirosVisitas();

          this.mostrar_modal_observacao = false;            
          this.processando = false;
        } catch (error) {
          this.verificarErro(error, 'salvarObservacao');   
        }
      },

      limparRoteiroSelecionado(){
        this.roteiro_selecionado = undefined;
        this.buscarCarteiraClientes(0); 
      },

      abrirDadosPedido(orcamento_id) {
        this.orcamento_detalhe = parseInt(this.strPadraoToNumber(orcamento_id));
        this.mostrar_modal_dados_orcamento = true;
      },

      async adicionarRoteiro(roteiro){
        this.roteiro_selecionado = undefined;

        if (roteiro){
          this.roteiro_selecionado = roteiro;
          await this.buscarCarteiraClientes(roteiro.roteiro_visitas_id); 
        } else{
          await this.buscarCarteiraClientes(0); 
        }
      },

      novoRoteiro(){
        if (this.aut_criar_alterar_roteiros_visitas == 'N'){
          Biblioteca.exclamar('Usuário não autorizado a criar roteiro de visitas!');
          return;
        }

        this.roteiro_edicao = {};
        this.roteiro_edicao.replicar = 'NEN';
        this.roteiro_edicao.qtd_vezes_replicar = 0;

        this.mostrar_modal_roteiro = true;
        this.mostrar_mais_botoes = false;
      },

      copiarRoteiro(roteiro){
        if (this.aut_criar_alterar_roteiros_visitas == 'N'){
          Biblioteca.exclamar('Usuário não autorizado a criar roteiro de visitas!');
          return;
        }

        this.roteiro_edicao = {};
        this.roteiro_edicao.replicar = 'NEN';
        this.roteiro_edicao.qtd_vezes_replicar = 0;

        if (!roteiro){
          Biblioteca.exclamar('Nenhum roteiro foi selecionado!');
          return;
        }

        this.roteiro_edicao.copia_roteiro_visitas_id = roteiro.roteiro_visitas_id;
        this.roteiro_edicao.nome = roteiro.nome;

        this.mostrar_modal_roteiro = true;
        this.mostrar_mais_botoes = false;
      },

      alterarRoteiro(roteiro){
        this.roteiro_edicao = {};

        if (!roteiro){
          Biblioteca.exclamar('Nenhum roteiro foi selecionado!');
          return;
        }

        if (this.aut_criar_alterar_roteiros_visitas == 'N' && this.aut_alterar_excluir_roteiros_visitas_ja_iniciados == 'N'){
          Biblioteca.exclamar('Usuário não autorizado a alterar roteiro de visitas!');
          return;
        }

        if (this.aut_criar_alterar_roteiros_visitas == 'N' && roteiro.status == 'ABE'){
          Biblioteca.exclamar('Usuário não autorizado a alterar roteiro de visitas que está em aberto!');
          return;
        }

        if (this.aut_alterar_excluir_roteiros_visitas_ja_iniciados == 'N' && roteiro.status != 'ABE'){
          Biblioteca.exclamar('Usuário não autorizado a alterar roteiro de visitas que já foi iniciado!');
          return;
        }

        this.roteiro_edicao.roteiro_visitas_id = roteiro.roteiro_visitas_id;
        this.roteiro_edicao.funcionario_id = roteiro.funcionario_id;
        this.roteiro_edicao.nome = roteiro.nome;
        this.roteiro_edicao.status = roteiro.status;
        this.roteiro_edicao.data_inicial = moment(roteiro.data_inicial, 'DD/MM/YYYY').format('YYYY-MM-DD');
        this.roteiro_edicao.data_final = moment(roteiro.data_final, 'DD/MM/YYYY').format('YYYY-MM-DD'); 
        this.roteiro_edicao.replicar = roteiro.replicar;
        this.roteiro_edicao.qtd_vezes_replicar = roteiro.qtd_vezes_replicar;

        this.mostrar_modal_roteiro = true;
        this.mostrar_mais_botoes = false;
      },

      async excluirRoteiro(roteiro, questionar_tipo_exclusao){
        if (!roteiro){
          Biblioteca.exclamar('Nenhum roteiro foi selecionado!');
          return;
        }

        if (this.aut_criar_alterar_roteiros_visitas == 'N' && this.aut_alterar_excluir_roteiros_visitas_ja_iniciados == 'N'){
          Biblioteca.exclamar('Usuário não autorizado a excluir roteiro de visitas!');
          return;
        }

        if (this.aut_criar_alterar_roteiros_visitas == 'N' && roteiro.status == 'ABE'){
          Biblioteca.exclamar('Usuário não autorizado a excluir roteiro de visitas que está em aberto!');
          return;
        }

        if (this.aut_alterar_excluir_roteiros_visitas_ja_iniciados == 'N' && roteiro.status != 'ABE'){
          Biblioteca.exclamar('Usuário não autorizado a excluir roteiro de visitas que já foi iniciado!');
          return;
        }

        if ((roteiro.replicar != 'NEN') && questionar_tipo_exclusao){
          this.tipo_exclusao_roteiro_replicado = 'T';
          this.mostrar_modal_opcoes_excluir_roteiro = true;
          return;
        }

        if (questionar_tipo_exclusao){
          this.tipo_exclusao_roteiro_replicado = 'N';
        } else{
          this.mostrar_modal_opcoes_excluir_roteiro = false;
        }

        try {
          await swal(
            (roteiro.status == 'ABE' ? '' : "As fotos e observações cadastras serão excluidas. ") + 
            "Deseja realmente excluir o roteiro " + this.formatarValor(roteiro.roteiro_visitas_id, 0) + '-' + (roteiro.nome ? roteiro.nome : 'SEM NOME') + "?", 
            {
              buttons: {
                sim: "Sim",
                nao: "Não"                
              },
            }
          ).then(async (value)=> {
            switch (value) {
              case "sim":
              this.processando = true;

              let parametros = {
                roteiro_visitas_id: roteiro.roteiro_visitas_id,
                tipo_exclusao_roteiro_replicado: this.tipo_exclusao_roteiro_replicado
              }

              let retorno = await RRoteiro.excluirRoteiroVisita(this.axios, parametros);

              if (retorno.houve_erro == 'S'){
                throw new Error(retorno.mensagem);
              }

              let roteiro_visitas_id = roteiro.roteiro_visitas_id;

              swal(
                'Operação realizada com sucesso.',
                'Roteiro ' + roteiro_visitas_id + ' excluido com sucesso.', 
                 "success"
              );

              if (this.roteiro_selecionado && (this.roteiro_selecionado.roteiro_visitas_id == roteiro.roteiro_visitas_id)){
                await this.limparRoteiroSelecionado();  
              }

              await this.buscarRoteirosVisitas();

              this.processando = false;
              break;
            }
          });
        } catch (error) {
          this.verificarErro(error, 'removerClienteRoteiro');   
        }
      },

      async baixarRoteiro(roteiro){
        if (!roteiro){
          Biblioteca.exclamar('Nenhum roteiro foi selecionado!');
          return;
        }

        if (roteiro.status == 'ABE'){
          Biblioteca.exclamar('Somente roteiros com status em progresso podem ser baixados!');
          return;
        }

        try {
          await swal(
            "Deseja realmente baixar o roteiro " + this.formatarValor(roteiro.roteiro_visitas_id, 0) + '-' + roteiro.nome + "?", 
            {
              buttons: {
                sim: "Sim",
                nao: "Não"                
              },
            }
          ).then(async (value)=> {
            switch (value) {
              case "sim":
              this.processando = true;

              let parametros = {
                roteiro_visitas_id: roteiro.roteiro_visitas_id,
              }

              let retorno = await RRoteiro.baixarRoteiroVisita(this.axios, parametros);

              if (retorno.houve_erro == 'S'){
                throw new Error(retorno.mensagem);
              }

              let roteiro_visitas_id = roteiro.roteiro_visitas_id;

              swal(
                'Operação realizada com sucesso.',
                'Roteiro ' + roteiro_visitas_id + ' baixado com sucesso.', 
                 "success"
              );

              await this.limparRoteiroSelecionado();
              await this.buscarRoteirosVisitas();

              this.processando = false;
              break;
            }
          });
        } catch (error) {
          this.verificarErro(error, 'removerClienteRoteiro');   
        }
      },

      async exibirFotosVisita(cliente){
        if (!cliente){
          Biblioteca.exclamar('Nenhum cliente foi selecionado!');
          return;
        }

        try {
          this.item_roteiro_edicao = {};
          this.titulo_foto_0 = '';
          this.titulo_foto_1 = '';
          this.titulo_foto_2 = '';
          this.titulo_foto_3 = '';
          this.data_hora_envio_foto_0 = '';
          this.data_hora_envio_foto_1 = '';
          this.data_hora_envio_foto_2 = '';
          this.data_hora_envio_foto_3 = '';
          
          this.item_roteiro_edicao.roteiro_visitas_id = cliente.roteiro_visitas_id;
          this.item_roteiro_edicao.visita_id = cliente.visita_id;
          this.processando = true;

          let parametros = {
            roteiro_visitas_id: this.item_roteiro_edicao.roteiro_visitas_id,
            visita_id: this.item_roteiro_edicao.visita_id,
            tipo_foto: 'VIS'
          }

          let retorno = await RRoteiro.buscarFotosVisita(this.axios, parametros);

          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }

          for (let i = 0; i < retorno.dados.length; i++) {
            if (i > 4){
              break;
            }

            this.carregarImagem(i, retorno.dados[i].foto, retorno.dados[i].titulo, retorno.dados[i].data_hora_envio);
          }

          this.mostrar_modal_fotos_visita = true;
          this.processando = false;
        } catch (error) {
          this.item_roteiro_edicao = {};
          this.verificarErro(error, 'exibirFotosVisita');
        }
      },

      lerArquivo(){
        try {
          let input = document.getElementById('ifotos')

          if (!input) {
            return
          }

          if (!input.files) {
            return
          }

          var carregarImagem = new FileReader();
          var nomeImagem = '#img0' + this.imagemSelecionada;
          var processando = true;
          
          carregarImagem.readAsDataURL(input.files[0]);
          carregarImagem.onload = (arquivo) => {
            $(nomeImagem).attr('src', arquivo.target.result);
          }
        } catch (error) {
          this.verificarErro(error, 'lerArquivo');
        }
      },

      carregarImagem(indice, base64, titulo, data_hora_envio){
        try {
          let contentType = 'image/png';

          let blob = this.base64toBlob(base64, contentType);
          let blobUrl = URL.createObjectURL(blob);

          let carregarImagem = new FileReader();
          let nomeImagem = '#img0' + (indice + 1);
          carregarImagem.readAsDataURL(blob);

          carregarImagem.onload = (arquivo) => {
            $(nomeImagem).attr('src', arquivo.target.result);
          }
          
          if (indice == 0){
            this.titulo_foto_0 = titulo;
            this.data_hora_envio_foto_0 = data_hora_envio;
          } else if (indice == 1){
            this.titulo_foto_1 = titulo;
            this.data_hora_envio_foto_1 = data_hora_envio;
          } else if (indice == 2){
            this.titulo_foto_2 = titulo;
            this.data_hora_envio_foto_2 = data_hora_envio;
          } else if (indice == 3){
            this.titulo_foto_3 = titulo;
            this.data_hora_envio_foto_3 = data_hora_envio;
          }
        } catch (error) {
          this.verificarErro(error, 'carregarImagem');
        }
      },

      base64toBlob(base64Data, contentType, sliceSize) {
        try {
          contentType = contentType || '';
          sliceSize = sliceSize || 512;

          var byteCharacters = atob(base64Data);
          var byteArrays = [];

          for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);

            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
              byteNumbers[i] = slice.charCodeAt(i);
            }

            var byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
          }
            
          var blob = new Blob(byteArrays, {type: contentType});

          return blob;
          
        } catch (error) {
          this.verificarErro(error, 'base64toBlob');
          return null;
        }
      },

      adicionarFoto: function(imgClicada) {
        this.imagemSelecionada = imgClicada;
        document.getElementById('ifotos').click();
      },

      limparFoto: function(indice) {
        document.getElementById('img0' + (indice + 1)).src = this.fotoPadrao;

        if (indice == 0){
          this.titulo_foto_0 = '';
          this.data_hora_envio_foto_0 = '';
        } else if (indice == 1){
          this.titulo_foto_1 = '';
          this.data_hora_envio_foto_1 = '';
        } else if (indice == 2){
          this.titulo_foto_2 = '';
          this.data_hora_envio_foto_2 = '';
        } else if (indice == 3){
          this.titulo_foto_3 = '';
          this.data_hora_envio_foto_3 = '';
        }
      },

      async enviarFotosVisita(){
        try {
          this.processando = true;
          let imagens = document.getElementsByTagName("img");

          let fotos = [
            {base64: undefined, titulo: undefined},
            {base64: undefined, titulo: undefined},
            {base64: undefined, titulo: undefined},
            {base64: undefined, titulo: undefined},
          ];

          for (let i = 0; i < imagens.length; i++){

            if (imagens[i].src.indexOf(this.fotoPadrao) != -1)
              continue;

            // Compactando fotos
            let mime_type = "image/jpeg";
            let maxWidth = 1000;
          
            let natW = imagens[i].naturalWidth;
            let natH = imagens[i].naturalHeight;
            let ratio = natH / natW;

            if (natW > maxWidth) {
              natW = maxWidth;
              natH = ratio * maxWidth;
            }

            let cvs = document.createElement('canvas');
            cvs.width = natW;
            cvs.height = natH;

            let ctx = cvs.getContext("2d").drawImage(imagens[i], 0, 0, natW, natH);
            // Compactando fotos para 60% de qualidade
            let newImageData = cvs.toDataURL(mime_type, 60 / 100);

            let result_image_obj = new Image();
            result_image_obj.src = newImageData;

            let base64 = result_image_obj.src
            base64 = base64.replace(/^data:image\/[a-z]+;base64,/, "")

            if (imagens[i].id == 'img01'){
              fotos[0].base64 = base64;
              fotos[0].titulo = this.titulo_foto_0;
              fotos[0].data_hora_envio = this.data_hora_envio_foto_0;
            }
            else if (imagens[i].id == 'img02'){
              fotos[1].base64 = base64;
              fotos[1].titulo = this.titulo_foto_1;
              fotos[1].data_hora_envio = this.data_hora_envio_foto_1;
            }
            else if (imagens[i].id == 'img03'){
              fotos[2].base64 = base64;
              fotos[2].titulo = this.titulo_foto_2;
              fotos[2].data_hora_envio = this.data_hora_envio_foto_2;
            }
            else if (imagens[i].id == 'img04'){
              fotos[3].base64 = base64;
              fotos[3].titulo = this.titulo_foto_3;
              fotos[3].data_hora_envio = this.data_hora_envio_foto_3;
            }
          }

          // Descobrindo a quantidade de fotos a ser enviada para o servidor
          let qtd_fotos_enviadas = 0;
          let foto_envio_atual = 0;

          for (let i = 0; i < fotos.length; i++){
            if (fotos[i].base64 == undefined)
              continue;
              
            qtd_fotos_enviadas++; 
          }

          // Enviando fotos para o servidor.
          let ordem = -1;
          for (let i = 0; i < fotos.length; i++){
            if (fotos[i].base64 == undefined)
              continue;

            ordem++;
            foto_envio_atual++;
            this.descricao_processando_fotos = 'Enviando fotos ' + foto_envio_atual + '/' + qtd_fotos_enviadas + '..';

            let parametros = {
              roteiro_visitas_id: this.item_roteiro_edicao.roteiro_visitas_id,
              visita_id: this.item_roteiro_edicao.visita_id,
              ordem: ordem,
              titulo: fotos[i].titulo,
              data_hora_envio: fotos[i].data_hora_envio,
              foto_base64: fotos[i].base64
            }

            let retorno = await RRoteiro.registrarFotoVisita(this.axios, parametros);

            if (retorno.houve_erro == 'S'){
              throw new Error(retorno.mensagem);
            }
          }

          // Caso nenhuma foto seja enviada apagando as outras fotos da visita.
          if (ordem == -1){
            this.descricao_processando_fotos = 'Excluindo fotos da visita..';

            let parametros = {
              roteiro_visitas_id: this.item_roteiro_edicao.roteiro_visitas_id,
              visita_id: this.item_roteiro_edicao.visita_id
            }

            let retorno = await RRoteiro.excluirTodasFotosVisita(this.axios, parametros);

            if (retorno.houve_erro == 'S'){
              throw new Error(retorno.mensagem);
            }
          }

          this.processando = false;
          this.mostrar_modal_fotos_visita = false;
          this.descricao_processando_fotos = '';
        } catch (error) {
          this.verificarErro(error, 'enviarFotos'); 
        }
      },

      getPeriodoRoteiro(data_inicial, data_final){
        if (data_inicial === data_final) {
          return '' + data_inicial + '';
        } else {
          return '' + data_inicial + ' até ' + data_final + '';
        }
      },

      verificarErro(erro, nome_funcao){
        this.processando = false;
        this.descricao_processando_fotos = '';
        let mensagem = Biblioteca.tratamentoMensagem(erro);
        Biblioteca.exclamar(mensagem);
      },

      getCorFundoStatusVisita(cliente){
        let style = "";

        if (cliente.mostrarDetalhes) {
          style = style + "border: 1px solid #bfbfbf; box-shadow: #7a7a7a 1px 2px 5px 2px;";
        }

        if (cliente.status == 'FIN'){
          style = style + "background-color: #dedede;";
        }

        return style;
      },

      getStyleStatusVisita(status){
        if (status == 'PLA'){
          return "color: #5c9c60;"
        } 
        else if (status == 'EAN'){ 
          return "color: #31607d;"
        } 
        else if (status == 'FIN'){ 
          return "color: #7a366c;"
        }  
      },

      getIconeStatus(status){
        if (status == 'PLA'){
          return "fa fa-route texto-vermelho";
        }
        else if (status == 'EAN'){
          return "fa fa-road texto-vermelho";
        }
        else if (status == 'FIN'){
          return "fa fa-map-marker-alt texto-vermelho";
        }
      },

      getIconeCliente(roteiro_visitas_id){
        if (roteiro_visitas_id > 0){
          return "fa fa-user texto-vermelho";
        } 
        else {
          return "fa fa-user-slash texto-vermelho";
        }
      },

      getPrimeiraLetraNome(nome){
        return nome.substr(0, 1);
      },

      getStyleEndereco(cep){
        if (cep){
          return "link w3-text-blue-grey";
        } 
        else {
          return "";
        }
      },

      getStyleResultado(resultado){
        if (resultado == 'NDE'){
          return "color: #b35959;";
        }
        else if (resultado == 'POS'){
          return "color: #a3557f;";
        } 
        else if (resultado == 'EST'){
          return "color: #7f9ed4;";
        }
        else if (resultado == 'PRE'){
          return "color: #56967b;";
        }
        else if (resultado == 'INA'){
          return "color: #759656;";
        }
        else if (resultado == 'LIM'){
          return "color: #63a873;";
        }
        else if (resultado == 'EXC'){
          return "color: #cca36e;";
        }
        else if (resultado == 'NAO'){
          return "color: #5b88b0;";
        }
        else if (resultado == 'OUT'){
          return "color: #91b05b;"; 
        }
      },

      getIconeResultado(resultado){
        if (resultado == 'NDE'){
          return "fa fa-question-circle";
        }
        else if (resultado == 'POS'){
          return "fa fa-shopping-cart";
        } 
        else if (resultado == 'EST'){
          return "fa fa-dolly";
        }
        else if (resultado == 'PRE'){
          return "fa fa-comment-dollar";
        }
        else if (resultado == 'INA'){
          return "fa fa-user-lock";
        }
        else if (resultado == 'LIM'){
          return "fa fa-credit-card";
        }
        else if (resultado == 'EXC'){
          return "fa fa-id-card-alt";
        }
        else if (resultado == 'NAO'){
          return "fa fa-user-slash";
        }
        else if (resultado == 'OUT'){
          return "fa fa-info-circle";
        }
      },

      limparPesquisaPorNomeCliente(){
        document.getElementById("txtPesquisaCliente").value = '';
        this.pesquisarPorNomeCliente();
      },

       limparPesquisaPorNomeRoteiro(){
        document.getElementById("txtPesquisaRoteiro").value = '';
        this.pesquisarPorNomeRoteiro();
      },

      async upperCase(campo){
        document.getElementById(campo).value = document.getElementById(campo).value.toUpperCase();
      },

      async pesquisarPorNomeCliente(){
        document.getElementById("txtPesquisaCliente").value = document.getElementById("txtPesquisaCliente").value.toUpperCase();
        let chave_pesquisa = document.getElementById("txtPesquisaCliente").value;
        this.clientes_carteira = [];

        if (chave_pesquisa == '') {
          for (let i = 0; i < this.clientes_carteira_aux.length; i++){
            this.clientes_carteira.push(this.clientes_carteira_aux[i]);
          }

          await this.ajustarTituloCliente();
          return;
        }

        for (let i = 0; i < this.clientes_carteira_aux.length; i++){
          if (this.clientes_carteira_aux[i].nome_fantasia.indexOf(chave_pesquisa) != -1){
            this.clientes_carteira.push(this.clientes_carteira_aux[i]);
          }
        }

        await this.ajustarTituloCliente();
      },

      ajustarTituloCliente(){
        let exibir_titulo_visita = true;
        let exibir_titulo_carteira = true;

        for (let i = 0; i < this.clientes_carteira.length; i++){
          this.clientes_carteira[i].exibir_titulo_visita = false;
          this.clientes_carteira[i].exibir_titulo_carteira = false;

          if (exibir_titulo_visita && (parseInt(this.clientes_carteira[i].roteiro_visitas_id) > 0)){
            this.clientes_carteira[i].exibir_titulo_visita = true;
            exibir_titulo_visita = false;
          } else if (exibir_titulo_carteira && (parseInt(this.clientes_carteira[i].roteiro_visitas_id) == 0)){
            this.clientes_carteira[i].exibir_titulo_carteira = true;
            exibir_titulo_carteira = false;
          }
        }
      },

      pesquisarPorNomeRoteiro(){
        document.getElementById("txtPesquisaRoteiro").value = document.getElementById("txtPesquisaRoteiro").value.toUpperCase();
        let chave_pesquisa = document.getElementById("txtPesquisaRoteiro").value;
        this.roteiros = [];

        if (chave_pesquisa == '') {
          for (let i = 0; i < this.roteiros_aux.length; i++){
            this.roteiros.push(this.roteiros_aux[i]);
          }

          return;
        }

        for (let i = 0; i < this.roteiros_aux.length; i++){
          if (this.roteiros_aux[i].nome.indexOf(chave_pesquisa) != -1){
            this.roteiros.push(this.roteiros_aux[i]);
          }
        }
      },

      async buscarRoteirosVisitas(){
        try {
          this.roteiros = [];
          this.roteiros_aux = [];

          let parametros = {};

          let retorno = await RRoteiro.buscarRoteirosVisitas(this.axios, parametros);

          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }

          this.roteiros = retorno.dados;
          this.roteiros_aux = retorno.dados;

          if (!this.roteiro_selecionado){
            await this.adicionarRoteiro(undefined);
            return;
          }

          let encontrou_roteiro = false;
          for (let i = 0; i < this.roteiros.length; i++){
            if (this.roteiro_selecionado.roteiro_visitas_id == this.roteiros[i].roteiro_visitas_id){
              await this.adicionarRoteiro(this.roteiros[i]);
              encontrou_roteiro = true;
            }
          }

          if (!encontrou_roteiro){
            this.limparRoteiroSelecionado();  
          }
        } catch (error) {
          let mensagem = Biblioteca.tratamentoMensagem(error);
          Biblioteca.exclamar(mensagem);  
        }
      },

      async trocarAba(novaAba){
        this.aba_selecionada = novaAba;
      },

      exibirFinanceirosAberto(cliente){
        this.$refs.financeirosAbertoCliente.buscarFinanceirosAbertos(cliente); 
      },

      valorInt(numero){
        return Biblioteca.valorInt(numero);
      },

    },
    
    created: function(){
      this.buscarAutorizacoes();
      this.buscarRoteiroMaisRelevante();
    } 
  }
</script>

<style escoped>

  .card-item {
    background: white;
    border-radius: 10px;
    margin-bottom: 10px;
    padding: 5px !important;
    border: 2px solid #ccc;
  }

  .icone {
    padding: 11px;
    background: gray;
    color: white;
    min-width: 15px;
    text-align: center;
    border-left-style: none
  }

  .link{
    color: -webkit-link;
    cursor: pointer;
    color: #335696;
    font-size:14px; 
    text-decoration: underline;
  }

  .botao-remover {
    padding: 11px;
    background: white;
    color: gray;
    min-width: 15px;
    text-align: center;
    border-left-style: none
  }

  .botao-remover:active {
    background-color: #ccc;
    box-shadow: 0 1px #666;
    transform: translateY(1px);
  }

  .tamanho-fonte-detalhes {
    font-size:14px; 
  }

  .fonte-resultado {
    font-size:12px; 
    font-style: italic;
  }

  .fundo-cabecalho-dados {
    margin-left: 2px;
    margin-bottom: 0px;
    margin-top: 5px;
    border-radius: 5px;
    font-size: 15px;
  }

  .fundo-cabecalho-vermelho {
    background-color: #9c1d1c;
    color: white;
    margin-left: 2px;
    border-radius: 5px;
    font-size: 14px;
  }

  .fundo-cabecalho-cinza {
    margin-left: 2px;
    border-radius: 5px;
    font-size: 14px;
  }

  .fundo-cabecalho-copiando-roteiro {
    background-color: #9e3a5c;
    color: white;
    margin-left: 2px;
    border-radius: 5px;
    font-size: 14px;
  }

  .cor-botao {
    color: white;
    background-color: #994137;
  }

  .cor-botao-incluir-roteiro {
    color: white;
    background-color: #4f8075;
  }

  .cor-botao-atualizar-roteiro {
    color: white;
    background-color: #916e40;
  }

  .cor-botao-remover-roteiro {
    color: white;
    background-color: #31607d;
  }

  .cor-botao-definir-horario {
    color: white;
    background-color: #4f8075;
  }

  .cor-botao-novo-pedido {
    color: white;
    background-color: #64578a;
  }

  .cor-botao-check-in {
    color: white;
    background-color: #497a49;
  }

  .cor-botao-upload-fotos {
    color: white;
    background-color: #42649e;
  }

  .cor-botao-financeiro {
    color: white;
    background-color: #994137;
  }

  .cor-botao-upload-observacao {
    color: white;
    background-color: #826c40;
  }

  .cor-botao-observacao-check-out {
    color: white;
    background-color: #42649E;
  }

  .cor-botao-check-out {
    color: white;
    background-color: #9e3a5c;
  }

  .cor-icone-endereco {
    color: #264275;
  }

  .cor-icone-telefone {
    color: #409152;
  }

  .cor-botao-visualizar-pedido {
    color: #994137;
  }
  
  .cor-icone-pedido {
    color: #994137;
  }

  .cor-icone-vendedor {
    color: #42649e;
  }

  .cor-icone-empresa {
    color: #806f4f;
  }

  .cor-icone-condicao {
    color: #64578a;
  }

  .cor-icone-total-pedido {
    color: #388f36;
  }

  .imagem{
    max-width: 100%;
    border-radius: 5px;
    border: 1px solid #808080;
    overflow:hidden;
  }

  .foto-cabecalho > span:hover, .foto-cabecalho > span{
    border-radius: 25px;
    right: 10px;
    top: 10px;
    background-color: white!important;
    color: black;
  }

   /*carregando classes*/
  .carregando,
  .carregando:before,
  .carregando:after {
    border-radius: 50%;
    width: 1.5em;
    height: 1.5em;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    -webkit-animation: load7 1.8s infinite ease-in-out;
    animation: load7 1.8s infinite ease-in-out;
  }

  .carregando {
    color: hsl(0, 69%, 22%);
    font-size: 10px;
    margin: 30px auto;
    position: relative;
    text-indent: -9999em;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
  }

  .carregando:before,
  .carregando:after {
    content: '';
    position: absolute;
    top: 0;
  }

  .carregando:before {
    left: -3.5em;
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
  }

  .carregando:after {
    left: 3.5em;
  }

  @-webkit-keyframes load7 {
    0%,
    80%,
    100% {
      box-shadow: 0 2.5em 0 -1.3em;
    }
    40% {
      box-shadow: 0 2.5em 0 0;
    }
  }

  @keyframes load7 {
    0%,
    80%,
    100% {
      box-shadow: 0 2.5em 0 -1.3em;
    }
    40% {
      box-shadow: 0 2.5em 0 0;
    }
  }

  .cor-botao-remover-roteiro {
    color: white;
    background-color: #31607d;
  }

  .cor-botao-alterar-roteiro {
    color: white;
    background-color: #4f8075;
  }

  .cor-botao-baixar-roteiro {
    color: white;
    background-color: #2ba652;
  }

  .cor-botao-novo-roteiro {
    color: white;
    background-color: #684f80;
  }

  .cor-botao-copiar-roteiro {
    color: white;
    background-color: #9e3a5c;
  }

  .cor-icone-principal {
    color: #9c1d1c;
  }

  .circulo-letra {
    width: 25px; 
    height: 25px; 
    background-color: #9c1c36; 
    color: #ffffff; 
    background-size: cover; 
    font-weight: bold; 
    font-size: 16px; 
    display: inline-block; 
    padding-top: 1px;
  }

  .input-pesquisa {
    border-radius: 10px;
    outline:none;
    border: 2px solid #ccc;
    padding-left: 15px;
    width: 98%; 
    font-size:14px;
  }

  .input-pesquisa:focus {
    border: 1px solid #bfbfbf;
    box-shadow: #7a7a7a 1px 2px 5px 2px;
  }

  .botao-pesquisa {
    border: 0px;
    margin-bottom: 5px;
    border-radius: 15px;
    height: 30px;
    width: 30px;
    color: #6e6e6e;
    background-color: white;
    margin-left: -50px;
  }

  .botao-pesquisa:focus {
    background-color: white;
    outline:none;
    color: #2193F6;
  }

  .botao-ativo-abas {
    background-color: #d4d4d4!important; 
    color: #333333!important;
    width: 100%;
    padding:8px 0px; 
    border-radius: 5px;
    outline:none;
    border: 1px solid #bfbfbf;
    box-shadow: #7a7a7a 1px 2px 5px 2px;
  }


</style>





// WEBPACK FOOTER //
// src/components/CarteiraCliente.vue